/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-useless-computed-key */
export default {
	['较大']: 'Больше',
	['预设']: 'По умолчанию',
	['较小']: 'Меньше',
	['字级大小']: 'Размер шрифта',
	['页面正在加载中']: 'Загрузка страницы',
	['这可能需要几分钟的时间，请耐心等待']: 'Это может занять несколько минут, пожалуйста, подождите терпеливо.',
	['您所访问的页面不存在']: 'Запрашиваемая страница не существует',
	['开始对话']: 'Начать чат',
	['充值未到帐快速通道']: 'Помощь: Деньги не поступили',
	['人工客服']: 'Человеческое обслуживание клиентов',
	['已接听']: 'Отвечено',
	['结束对话']: 'Завершить чат',
	['联络人工客服']: 'Связаться с оператором',
	['重新选择智能客服']: 'Вернуться к виртуальному помощнику',
	['感谢您使用本次服务，烦请拨冗补充填写调查，您宝贵的意见是我们前进的动力！']: 'Спасибо за использование нашего сервиса, пожалуйста, найдите время заполнить опрос, ваше ценное мнение - это наш движущий фактор!',
	['您觉得此次的服务品质如何？']: 'Как вы оцениваете качество предоставленных услуг?',
	['颗星']: 'Звезд',
	['颗星(單數)']: 'Звезд',
	['不评分']: 'Не оценивать',
	['点选下方即可结束对话']: 'Нажмите ниже, чтобы завершить диалог',
	['请输入您的ID']: 'Введите ваш ID',
	['ID不能为空']: 'ID не может быть пустым',
	['说明文字']: 'Описание',
	['送出']: 'Отправить',
	['系统维护中']: 'Система на техобслуживании',
	['储存']: 'Сохранить',
	['确认']: 'Подтвердить',
	['取消']: 'отменить',
	['完成']: 'завершить',
	['协作']: 'сотрудничество',
	['转接']: 'переключение',
	['离开']: 'Выйти',
	['请选择服务对象开始通话']: 'Выберите объект обслуживания, чтобы начать разговор.',
	['请填写表单']: 'Пожалуйста, заполните форму',
	['本对话已经结束']: 'Этот разговор уже завершен',
	['客服已逾 {{second}} 秒未回应']: 'Служба поддержки не ответила в течение {{second}} секунд',
	['历史对话']: 'исторический диалог',
	['查无资料']: 'Не найдено данных',
	['标签']: 'ярлык',
	['正在输入中...']: 'Ввод...',
	['于']: 'у',
	['档案容量限制']: 'Ограничение объема файла',
	['不能为空']: 'Не может быть пустым',
	['提交']: 'отправить',
	['满意度']: 'удовлетворенность',
	['IP未知']: 'IP неизвестен',
	['地区未知']: 'Регион неизвестен',
	['使用者环境未知']: 'Неизвестная среда пользователя',
	['关闭']: 'закрыть',
	['全萤幕截图成档案']: 'Скриншот всего экрана в файл',
	['Mac用户']: 'Пользователь Mac',
	['Windows用户']: 'Пользователи Windows',
	['Windows键']: 'Клавиша Windows',
	['全萤幕截图至剪贴簿']: 'Скриншот всего экрана в буфер обмена',
	['截图完成后请直接于文字输入处贴上']: 'После завершения скриншота, пожалуйста, вставьте его прямо в поле ввода текста.',
	['使用Windows内建截图工具或者QQ软件截图功能，截图完成后请直接于文字输入处贴上']: 'Используйте встроенный инструмент Windows или QQ для создания скриншота. Затем вставьте его прямо в поле ввода',
	['截图']: 'скриншот',
	['档案']: 'файл',
	['下载失败']: 'Не удаётся скачать',
	['请输入分类名称']: 'Введите название категории',
	['新增']: 'Добавить',
	['更新']: 'обновление',
	['请选择一个分类']: 'Выберите категорию',
	['请输入标题']: 'Введите заголовок',
	['请输入内文']: 'Введите текст',
	['请上传图片']: 'Пожалуйста, загрузите изображение',
	['快捷语']: 'Скороговорка',
	['图片']: 'изображение',
	['管理分类']: 'Управление классификацией',
	['新增分类']: 'Добавить категорию',
	['标题/内文']: 'Заголовок/Содержимое',
	['分类']: 'категория',
	['编辑']: 'Редактировать',
	['删除']: 'Удалить',
	['平台名称']: 'Платформа',
	['显示']: 'показать',
	['编辑服务平台']: 'Редакционный сервисный платформы',
	['若有服务中的客户，无法关闭服务平台']: 'Если есть клиенты в обслуживании, платформа обслуживания не может быть закрыта.',
	['确定']: 'Подтвердить',
	['人员列表']: 'Список кадров',
	['服务人数']: 'число обслуживаемых',
	['选择转接人员']: 'Выбор передающего лица',
	['按此上传图片']: 'Нажмите здесь, чтобы загрузить изображение',
	['确定要取消{{displayName}}协作邀请吗？']: 'Вы уверены, что хотите отменить приглашение на сотрудничество {{displayName}}?',
	['确定要结束{{displayName}}的协作吗？']: 'Вы уверены, что хотите завершить сотрудничество с {{displayName}}?',
	['等待协作中']: 'Ожидание сотрудничества',
	['协作中']: 'Сотрудничество',
	['负责人']: 'ответственный',
	['已选择']: 'Выбрано',
	['可协作人数已满']: 'Количество участников достигло максимума.',
	['选择协作人员']: 'Выбор коллеги',
	['提示']: 'Подсказка',
	['请输入讯息']: 'Введите сообщение',
	['确定已經完成？']: 'Убедитесь, что завершено?',
	['常用图片']: 'Часто используемые изображения',
	['用户']: 'пользователь',
	['个人']: 'личный',
	['公共']: 'общественный',
	['开始谈话']: 'Начать разговор',
	['等待中']: 'Ожидание',
	['客户已离开对话']: 'Клиент покинул разговор',
	['正在转接给']: 'Перенаправляется к',
	['邀请你加入协作']: 'Приглашаю тебя присоединиться к сотрудничеству',
	['请求转接']: 'Запрос на переадресацию',
	['正在服务中']: 'В работе',
	['编辑平台']: 'Редакционная платформа',
	['您的连线已中断']: 'Ваше соединение разорвано',
	['正尝试重新连线']: 'Попытка переподключиться',
	['重新登入']: 'войти снова',
	['请先登入']: 'Пожалуйста, войдите сначала',
	['帐号']: 'учетная запись',
	['帐号不能为空']: 'Аккаунт не может быть пустым',
	['请输入帐号']: 'Введите учетную запись',
	['密码']: 'пароль',
	['密码不能为空']: 'Пароль не может быть пустым',
	['请输入密码']: 'Введите пароль',
	['登录']: 'вход',
	['客服系统客服端']: 'Система обслуживания клиентов',
	['平台异动，请重新整理']: 'Платформа изменилась, пожалуйста, обновите.',
	['客服系统升级维护中，请您晚点再联系线上客服，谢谢']: 'Система обслуживания клиентов обновляется, пожалуйста, свяжитесь с онлайн-службой поддержки позже, спасибо.',
	['客服系统进入升级维护作业，很抱歉中断您的对话，请您晚点再联系线上客服']: 'Система обслуживания клиентов находится в процессе обновления, извините за прерывание вашего диалога, пожалуйста, свяжитесь с онлайн-сервисом позже.',
	['请稍后再试']: 'Пожалуйста, попробуйте позже',
	['是']: 'есть',
	['否']: 'нет',
	['等于']: 'равный',
	['包含']: 'содержит',
	['排除']: 'исключить',
	['大于']: 'больше',
	['少于']: 'менее',
	['数量区间']: 'количественный диапазон',
	['客服对话数']: 'Количество диалогов с клиентами',
	['客戶对话数']: 'число разговоров с клиентами',
	['即时资讯']: 'мгновенные новости',
	['报表分析']: 'анализ отчетов',
	['平均通话时间']: 'среднее время разговора',
	['回覆通话数']: 'Ответить на вызов',
	['平均等待时间']: ' gemiddeld время ожидания',
	['客户满意度']: 'Удовлетворенность клиентов',
	['历史对话记录']: 'Исторический диалог 기록',
	['操作日志']: 'Операционный журнал',
	['智能客服设定']: 'Интеллектуальные настройки обслуживания клиентов',
	['机器人设定']: 'Настройка робота',
	['版本管理']: 'Управление версиями',
	['档案总览']: 'Обзор файлов',
	['设定']: 'установка',
	['公司管理']: 'управление компанией',
	['维修管理']: 'ремонтное управление',
	['一般设定']: 'Общие настройки',
	['公告管理']: 'Управление объявлениями',
	['帐号管理']: 'Управление учетной записью',
	['平台管理']: 'Платформенное управление',
	['角色管理']: 'управление ролями',
	['团队管理']: 'командное управление',
	['标签管理']: 'Управление тегами',
	['查询']: 'запрос',
	['重置']: 'Сбросить',
	['今天']: 'Сегодня',
	['昨天']: 'вчера',
	['过去7天']: 'прошедшие 7 дней',
	['过去10天']: 'прошедшие 10 дней',
	['过去一个月']: 'прошлый месяц',
	['过去90天']: 'последние 90 дней',
	['LOGO 预览']: 'ПРЕДВАРИТЕЛЬНЫЙ ПРОСМОТР ЛОГОТИПА',
	['档案格式：PNG、JPG，长宽不超过']: 'Формат файла: PNG, JPG, ширина и высота не более',
	['档案太大或格式不支援']: 'Файл слишком большой или формат не поддерживается',
	['且档案大小不得大于']: 'и размер файла не должен превышать',
	['上传档案']: 'Загрузить файл',
	['新增IP白名单成功']: 'Успешно добавлен IP-адрес в белый список',
	['删除IP白名单成功']: 'Успешно удален белый список IP',
	['请输入欲查询的IP']: 'Введите IP, который вы хотите запросить',
	['请输入IP']: 'Введите IP',
	['备注']: 'заметка',
	['备注不能为空']: 'Заметка не может быть пустой',
	['请输入备注']: 'Введите примечание',
	['新增时间']: 'Новое время',
	['操作']: 'операция',
	['IP白名单']: 'IP белый список',
	['新增IP']: 'Добавить IP',
	['新增IP白名单']: 'Добавить белый список IP',
	['确定删除此IP?']: 'Вы уверены, что хотите удалить этот IP?',
	['平台']: 'платформа',
	['团队']: 'команда',
	['全体']: 'всё тело',
	['客服']: 'клиентская служба',
	['客服系统']: 'Система обслуживания клиентов',
	['个人帐号设定']: 'Настройки личного аккаунта',
	['最少6码']: 'Минимум 6 ярдов',
	['最多20码']: 'максимум 20 ярдов',
	['不能有空白']: 'Не должно быть пробелов',
	['应至少包含1个英文和数字']: 'Должно содержать хотя бы 1 букву английского алфавита и цифру.',
	['公司名称']: 'Название компании',
	['僅能输入英文和数字']: 'Можно вводить только английские буквы и цифры。',
	['应至少包含1个英文']: 'Должен содержать как минимум 1 английский',
	['最少5码']: 'Минимум 5 ярдов',
	['IP不能为空']: 'IP не может быть пустым',
	['非IP位址']: 'Не IP-адрес',
	['最多500个字']: 'Максимум 500 слов',
	['启用']: 'включить',
	['禁用']: 'запретить',
	['对话量']: 'объем диалога',
	['目前客户数']: 'Текущее количество клиентов',
	['目前客服数']: 'текущие числа службы поддержки',
	['接通对话量']: 'Подключение к разговору',
	['全部']: 'все',
	['最近一天']: 'последний день',
	['最近一周']: 'за последнюю неделю',
	['最近一月']: 'последний месяц',
	['新增过滤器']: 'Добавить фильтр',
	['请输入模組名称']: 'Введите название модуля',
	['储存过滤模組']: 'Сохранить фильтрационный модуль',
	['读取过滤模組']: 'Чтение фильтрующего модуля',
	['确定要删除模組']: 'Убедитесь, что вы хотите удалить модуль.',
	['分钟']: 'минуты',
	['接通时间']: 'Время соединения',
	['通话时间']: 'Время разговора',
	['请选择或输入时间']: 'Выберите или введите время',
	['等待时间']: 'время ожидания',
	['对话搜寻']: 'Диалоговый поиск',
	['请输入对话']: 'Введите диалог',
	['客戶 ID']: 'Клиент ID',
	['请输入客戶ID']: 'Введите ID клиента',
	['对话浏览模式']: 'Режим просмотра диалогов',
	['筆']: 'ручка',
	['客服本名']: 'служба поддержки настоящее имя',
	['进入时间']: 'время входа',
	['客服昵称']: 'Имя службы поддержки',
	['客服系统管理端']: 'Система управления службой поддержки',
	['数量']: 'количество',
	['尚未上传档案']: 'Еще не загружен файл',
	['输入文字']: 'Вводить текст',
	['请在此输入文字']: 'Пожалуйста, введите текст здесь',
	['添加项目']: 'Добавить элемент',
	['请选择']: 'Пожалуйста, выберите',
	['新增文字']: 'Добавить текст',
	['新增档案']: 'Добавить файл',
	['選項']: 'опция',
	['勾选标题']: 'Выберите заголовок',
	['文字內容不能为空']: 'Текст не может быть пустым',
	['添加']: 'Добавить',
	['上传标题']: 'Заголовок загрузки',
	['单选标题']: 'Одинарный выбор',
	['输入框标题']: 'Поле ввода заголовка',
	['请输入']: 'Пожалуйста, введите',
	['输入框']: 'вводное поле',
	['单选']: 'одиночный выбор',
	['核取方块']: 'флажок',
	['请选择一个标签']: 'Пожалуйста, выберите тег',
	['确定要删除此项目和其所有子项目？']: 'Вы уверены, что хотите удалить этот элемент и все его подэлементы?',
	['答案']: 'ответ',
	['表单']: 'форма',
	['清除此阶层设定']: 'Удалить эту настройку уровня',
	['请输入此阶层问题']: 'Введите этот уровень вопроса',
	['新增选项']: 'Добавить опцию',
	['新增表单']: 'Создать форму',
	['新增答案']: 'Добавить ответ',
	['新增充值表单']: 'Добавить форму пополнения',
	['若切换种类后, 将清除原有的和其子项目资料']: 'Если вы переключите тип, будут удалены оригинальные данные и связанные с ними подкатегории.',
	['确定要清除所有资料和其子项目资料？']: 'Вы уверены, что хотите удалить все данные и данные его подзадач?',
	['阶层']: 'слой',
	['开场语']: 'Введение',
	['开场语不能为空']: 'Введение не может быть пустым',
	['结尾感谢语']: 'благодарственная речь',
	['结尾感谢语不能为空']: 'Заключительная благодарственная фраза не может быть пустой',
	['发布']: 'публикация',
	['复制']: 'копировать',
	['选择目的平台']: 'Выбор целевой платформы',
	['确定复制到']: 'подтвердить копирование в',
	['是否要正式发布到使用环境？']: 'Должен ли я официально выпустить в рабочую среду?',
	['储存版本']: 'Хранить версию',
	['版本名称']: 'название версии',
	['请输入版本名称']: 'Введите название версии',
	['确定是否储存此版本']: 'Убедитесь, что хотите сохранить эту версию',
	['版本储存成功']: 'Версия успешно сохранена',
	['最多10个字']: 'Не более 10 символов',
	['公告一']: 'Объявление одно',
	['公告二']: 'Объявление два',
	['公告三']: 'Объявление три',
	['公告储存成功']: 'Объявление успешно сохранено',
	['标题']: 'Название',
	['內文']: 'внутреннее содержание',
	['修改登入密码']: 'Изменить пароль для входа',
	['修改基本资讯']: 'Изменить основную информацию',
	['昵称']: 'никнейм',
	['昵称不能为空']: 'Никнейм не может быть пустым',
	['请输入昵称']: 'Введите никнейм',
	['本名']: 'настоящее имя',
	['本名不能为空']: 'Имя не может быть пустым',
	['请输入本名']: 'Введите настоящее имя',
	['选择图像']: 'Выбрать изображение',
	['状态']: 'Состояние',
	['平台代码']: 'платформенный код',
	['平台代码不能为空']: 'Платформенный код не может быть пустым',
	['使用ID模式登入']: 'Вход с использованием ID模式',
	['新增平台']: 'новая платформа',
	['修改平台']: 'платформа изменений',
	['确定重新产生Key/IV?']: 'Вы уверены, что хотите заново сгенерировать ключ/IV?',
	['进入公司成功']: 'Войти в компанию успешно',
	['确定禁用公司?']: 'Убедитесь, что компания отключена?',
	['确定启用公司?']: 'Определить, включить компанию?',
	['修改公司']: 'Изменить компанию',
	['进入公司']: 'войти в компанию',
	['确定进入公司?']: 'Вы уверены, что хотите войти в компанию?',
	['新增标签']: 'Добавить метку',
	['代号']: 'код',
	['代号不可为空']: 'Код не может быть пустым',
	['名称']: 'название',
	['名称不可为空']: 'Название не может быть пустым',
	['颜色']: 'цвет',
	['颜色不可为空']: 'Цвет не может быть пустым',
	['进入标签']: 'войти в тег',
	['修改标签']: 'Изменить метку',
	['确定开启进入标签?']: 'Убедитесь, что хотите открыть вкладку?',
	['确定关闭进入标签?']: 'Убедиться, что закрыть входную вкладку?',
	['确定删除此标签?']: 'Вы уверены, что хотите удалить этот ярлык?',
	['标签创建成功']: 'Тег создан успешно',
	['标签更新成功']: 'Тег успешно обновлен',
	['进入标签更新成功']: 'Вход в тег обновлен успешно',
	['标签删除成功']: 'Тег удалён успешно',
	['请输入代号、名称等关键字']: 'Введите код, название и другие ключевые слова',
	['设定开场白成功']: 'Установка вступительного слова успешна',
	['客戶进入开场白']: 'Клиент вступительное слово',
	['客戶进入开场白不可为空']: 'Клиент должен ввести непустое введение.',
	['第一次通知时间']: 'Первое уведомление времени',
	['第{{count}}次通知时间']: 'Время {{count}} уведомления',
	['设置错误']: 'Настройка ошибки',
	['设定等待过长通知时间成功']: 'Успешно установлен долгий срок ожидания уведомления',
	['秒']: 'секунда',
	['对话自动断开时间']: 'Время автоматического разрыва диалога',
	['未发话时间']: 'непроизнесённое время',
	['未发话提示文字']: 'Не сказанное текстовое сообщение',
	['设定对话断开成功']: 'Успешно отключено общение',
	['Favicon预览']: 'Предварительный просмотр Favicon',
	['更换 Favicon 成功']: 'Смена Favicon прошла успешно',
	['档案格式：ICO，長寬不超過 32x32 px']: 'Формат файла: ICO, размеры не превышают 32x32 пикселя',
	['更换 LOGO 成功']: 'Успешная замена логотипа',
	['智能客服']: 'Виртуальный помощник',
	['设定通道成功']: 'Настройка канала успешна',
	['设定提示音效成功']: 'Установка звукового сигнала успешна',
	['单音']: 'монофонемный',
	['循环音']: 'циклический звук',
	['编号']: 'номер',
	['资料类型']: 'тип данных',
	['资料类型不可为空']: 'Тип данных не может быть пустым',
	['数字']: 'цифра',
	['字串']: 'строка',
	['布林']: 'Браун',
	['建立标签成功']: 'Создание метки успешно',
	['修改标签成功']: 'Изменение метки успешно',
	['删除标签成功']: 'Удаление метки прошло успешно',
	['更换 LOGO']: 'Замена логотипа',
	['更换 Favicon']: 'Сменить Favicon',
	['对话断开']: 'Диалог прерван',
	['等待过长通知时间']: 'Слишком долгое время ожидания уведомления',
	['开场白']: 'Вводное слово',
	['提示音效设定']: 'Звуковые настройки подсказок',
	['通道设定']: 'Канал настройки',
	['自定义标签']: 'Пользовательские метки',
	['开启维修模式将会停止客服系统运作。确定要开启嗎？']: 'Включение режима обслуживания остановит работу системы обслуживания клиентов. Вы уверены, что хотите включить его?',
	['关闭维修模式，客服系统将会继续运作。确定要关闭嗎？']: 'Закройте режим обслуживания, система обслуживания клиентов продолжит работать. Вы уверены, что хотите закрыть?',
	['状态更新成功']: 'Обновление статуса успешно',
	['通知讯息更新成功']: 'Уведомление об обновлении сообщения успешно',
	['维修模式']: 'Режим обслуживания',
	['通知讯息设定']: 'Настройки уведомлений',
	['尚未连线状态']: 'неподключённое состояние',
	['尚未连线状态描述']: 'Не подключённый статус описания',
	['已连线状态']: 'Подключено',
	['已连线状态描述']: 'Статус соединения',
	['开启成功']: 'Успешно запущено',
	['关闭成功']: 'Закрыто успешно',
	['关闭登入管理模式将会限制客戶藉由输入ID 进入客服，确定要关闭嗎？(若沒有提供客戶Profile资料则会进入错误页面)']: 'Закрытие режима управления входом ограничит клиентов в доступе к службе поддержки, уверены, что хотите закрыть? (Если профиль клиента не предоставлен, будет открыта страница с ошибкой)',
	['开启登入管理模式将会開放客戶藉由输入 ID 进入客服，确定要开启嗎？']: 'Включение режима управления входом позволит клиентам войти в службу поддержки, введя ID. Вы уверены, что хотите включить?',
	['请输入帐号、昵称、角色等关键字']: 'Введите имя учетной записи, никнейм, роль и другие ключевые слова',
	['新增角色']: 'Добавить персонажа',
	['修改角色']: 'Изменить персонажа',
	['角色创建成功']: 'Создание персонажа успешно завершено',
	['角色更新成功']: 'Обновление персонажа прошло успешно',
	['角色删除成功']: 'Удаление角色 прошло успешно',
	['请输入角色名称，平台，权限等关键字']: 'Введите имя персонажа, платформу, права доступа и другие ключевые слова',
	['关键字']: 'ключевое слово',
	['角色名称']: 'название персонажа',
	['角色名称不可为空']: 'Название персонажа не может быть пустым',
	['请输入角色名称']: 'Введите имя персонажа',
	['上级角色']: 'верховный роль',
	['上级角色不可为空']: 'Роль вышестоящего не может быть пустой',
	['权限']: 'разрешение',
	['确定删除此角色?']: 'Вы уверены, что хотите удалить этого персонажа?',
	['图像不能为空']: 'Изображение не может быть пустым',
	['新增团队']: 'Создать команду',
	['修改团队']: 'Изменение команды',
	['团队创建成功']: 'Команда успешно создана',
	['团队修改成功']: 'Команда успешно изменена',
	['团队删除成功']: 'Команда успешно удалена',
	['人数']: 'число',
	['新登入密码']: 'новый пароль для входа',
	['新密码不能设定與舊密码相同']: 'Новый пароль не может быть таким же, как старый пароль.',
	['新密码與確認密码不相同']: 'Новый пароль и пароль подтверждения не совпадают',
	['确定修改登入密码?']: 'Вы уверены, что хотите изменить пароль для входа?',
	['登入密码修改成功，请重新登入']: 'Пароль для входа успешно изменён, пожалуйста, войдите снова.',
	['个人资讯']: 'личная информация',
	['搜寻快捷语']: 'Поиск ярлыков',
	['登出']: 'выход',
	['帐密错误']: 'Ошибка учетной записи',
	['一']: 'один',
	['二']: 'два',
	['三']: 'три',
	['四']: 'четыре',
	['五']: 'пять',
	['六']: 'шесть',
	['七']: 'семь',
	['请输入客服本名、客服昵称等关键字']: 'Пожалуйста, введите настоящее имя службы поддержки, никнейм и другие ключевые слова.',
	['共 {{count}} 筆资料']: 'Всего {{count}} записей',
	['平台语言不能为空']: 'Платформенный язык не может быть пустым',
	['开启']: 'открыть',
	['语言']: 'язык',
	['切换语言']: 'Сменить язык',
	['语言名称']: 'язык',
	['系统设定']: 'Системные настройки',
	['储存成功']: 'Сохранено успешно',
	['发布成功']: 'Успешно опубликовано',
	['复制成功']: 'Копирование успешно',
	['项目选取']: 'Выбор проекта',
	['图像']: 'изображение',
	['角色']: 'роль',
	['新增帐号']: 'Добавить аккаунт',
	['角色不能为空']: 'Роль не может быть пустой',
	['登入密码']: 'пароль для входа',
	['请输入代号、名称、备注等关键字']: 'Введите код, название, примечания и другие ключевые слова',
	['确定删除此团队?']: 'Удалить эту команду?',
	['切换语言成功']: 'Язык успешно изменен',
	['确定要切换语言?']: 'Вы уверены, что хотите переключить язык?',
	['选项']: 'вариант',
	['选择语言']: 'Выберите язык',
	['修改成功']: 'Изменение успешно',
	['舊登入密码']: 'старый пароль для входа',
	['確認新登入密码']: 'Подтвердите новый пароль для входа',
	['语言切换成功，將重整页面以套用更新']: 'Смена языка прошла успешно, страница будет перезагружена для применения обновлений.',
	['笔 / 页']: 'перо / страница',
	['时段搜寻']: 'периодический поиск',
	['请选择时段']: 'Пожалуйста, выберите период.',
	['更换背景色']: 'сменить цвет фона',
	['设定背景颜色成功']: 'Успешно установлена фоновая окраска',
	['请重新登入']: 'Пожалуйста, войдите снова',
	['绑定谷歌验证']: 'Привязать Google аутентификатор',
	['解除绑定']: 'отвязать',
	['谷歌验证状态']: 'Состояние проверки Google',
	['已绑定']: 'Уже связано',
	['未绑定']: 'Непривязанный',
	['解绑谷歌验证失败']: 'Не удалось отменить аутентификацию Google',
	['二维码方式添加']: 'Добавление с помощью QR-кода',
	['请在 Google 身份验证器中采用添加条形码方式添加']: 'Пожалуйста, добавьте с помощью способа добавления штрих-кода в Google Authenticator.',
	['密钥方式添加']: 'Способ добавления ключа',
	['请在 Google 身份验证器中采用输入提供的密钥方式添加']: 'Пожалуйста, добавьте с помощью введенного ключа в Google Authenticator.',
	['密钥如下所示']: 'Ключ приведен ниже',
	['请再次输入登入密码']: 'Пожалуйста, введите пароль для входа еще раз.',
	['谷歌6位动态密码']: 'Шестизначный динамический пароль Google',
	['请绑定谷歌验证']: 'Пожалуйста, привяжите Google-авторизацию',
	['谷歌验证绑定成功']: 'Успешная привязка проверки Google',
	['解绑谷歌验证成功']: 'Успешное отключение проверки Google',
	['确定解绑谷歌验证？']: 'Убедитесь, что хотите отключить проверку Google?',
	['请输入谷歌动态码']: 'Введите код Google Authenticator',
	['谷歌动态码']: 'Гугл-аутентификатор',
	['谷歌动态码不能为空']: 'Код Google не может быть пустым',
	['谷歌动态码长度6码']: 'Длина динамического кода Google — 6 символов',
	['谷歌动态码错误']: 'Ошибка динамического кода Google',
	['內容']: 'содержимое',
	['搜寻']: 'поиск',
	['连线中断，点击“确定”即重新连线客服。']: 'Соединение прервано, нажмите "ОК", чтобы повторно соединиться с оператором.',
	['充值表单']: 'Форма пополнения',
	['网银充值']: 'Интернет-банкинг',
	['扫码充值']: 'Сканировать QR-код для пополнения',
	['带入目前帐号']: 'Вход в текущую учетную запись',
	['自行输入平台帐号']: 'Введите учетную запись платформы',
	['充值方式']: 'Способ пополнения',
	['平台帐号']: 'Аккаунт платформы',
	['充值金额']: 'Сумма пополнения',
	['付款人姓名']: 'ФИО плательщика',
	['确认语']: 'подтверждающее слово',
	['操作时间']: 'время работы',
	['操作者']: 'оператор',
	['请输入备注等关键字']: 'Введите примечание и ключевые слова',
	['操作类型']: 'Тип операции',
	['修改平台昵称']: 'Изменить никнейм платформы',
	['修改平台昵称成功']: 'Изменение никнейма платформы прошло успешно',
	['输入格式错误']: 'Ошибка формата ввода',
	['套用']: 'применить',
	['确定套用到']: 'Убедитесь, что применено к',
	['套用成功']: 'Применение успешно',
	['储存方式']: 'способ хранения',
	['储存時間']: 'время хранения',
	['系统发布']: 'Система выпускает',
	['手动储存']: 'ручное сохранение',
	['自动储存']: 'Автохранение',
	['预览']: 'предпросмотр',
	['最多350个字']: 'Максимум 350 слов',
	['修改']: 'изменение',
	['共同资讯管理']: 'Совместное управление информацией',
	['共同资讯创建成功']: 'Совместная информация успешно создана',
	['共同资讯修改成功']: 'Успешное изменение совместной информации',
	['新增共同资讯']: 'Добавить общую информацию',
	['修改共同资讯']: 'Изменить общую информацию',
	['删除成功']: 'Удаление успешно',
	['已设置于其他答案，无法删除']: 'Установлено в других ответах, невозможно удалить',
	['请输入名称、内容等关键字']: 'Введите имя, содержание и другие ключевые слова',
	['确定删除此共同资讯？']: 'Вы уверены, что хотите удалить эту общую информацию?',
	['共同资讯']: 'Совместная информация',
	['尚未选择共同资讯']: 'Еще не выбраны общие данные',
	['选择共同资讯']: 'Выбрать общую информацию',
	['选择']: 'выбор',
	['点击「确定」后，即覆盖该平台的快捷语设定']: 'После нажатия «ОК» настройки ярлыков этой платформы будут перезаписаны.',
	['已复制：目的平台']: 'Скопировано: целевая платформа',
	['是否离开客服系统？']: 'Вы действительно хотите покинуть чат?',
	['感谢您的作答，此次评分为：{{score}}分']: 'Спасибо за оценку! Ваш балл: {{score}}.',
	['共 {{count}} 筆']: 'Всего {{count}} записей',
	['分']: 'часть',
	['新增公司']: 'Добавить компанию',
	['翻译']: 'Перевод',
	['显示原文']: 'Показать оригинал',
	['解绑谷歌验证']: 'Отвязать Google-аутентификацию',
	['请输入名称 内容等关键字']: 'Введите название, содержание и ключевые слова',
	['表单选项']: 'Форма выбора',
	['年']: 'год',
	['等待时间颜色设定']: 'Ожидание времени цветовая настройка',
	['显示颜色']: 'Показать цвет',
	['确认删除此规则?']: 'Подтвердите удаление этого правила?',
	['页签']: 'вкладка',
	['超过 {{time}} 分钟']: 'Более {{time}} минут',
	['新增成功']: 'Добавлено успешно',
	['删除完成']: 'Удаление завершено',
	['等待时间(分钟)']: 'Время ожидания (минуты)',
	['时间']: 'время',
	['不可为空']: 'Не может быть пустым',
	['需为正整数']: 'должен быть положительным целым числом',
	['按平台名称排列(A-Z)']: 'По названию платформы (А-Я)',
	['按平台名称排列(Z-A)']: 'По названию платформы (от Я до А)',
	['旧版面模式']: 'Старый интерфейс',
	['自动翻译']: 'Автоматический перевод',
	['功能設定']: 'Настройки функций',
	['确认切换版面？']: 'Подтвердить переключение макета?',
	['确认开启自动翻译？']: 'Подтвердить включение автоперевода?',
	['确认关闭自动翻译？']: 'Подтвердите отключение автоматического перевода?',
	['原文']: 'В оригинале',
	['泰语']: 'тайский язык',
	['追踪']: 'отслеживать',
	['取消追踪']: 'Отменить отслеживание',
	['预览影片']: 'Предварительный просмотр видео',
	['仅能上传 MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF档案']: 'Можно загружать только файлы MP4, MOV, JPEG (JPG), PNG, GIF, HEIC, RAW, HEIF.',
	['请勿输入语法相关字串']: 'Не вводите программный код или спецсимволы',
	['输入名称']: 'введите имя',
	['设为预设版本']: 'Установить как версию по умолчанию',
	['另存为新版本']: 'Сохранить как новую версию',
	['请选择版本']: 'Пожалуйста, выберите версию',
	['一键开关']: 'Кнопка одного нажатия',
	['若有服务中的客户，无法关闭服务平台与切换版本']: 'Если есть клиенты в обслуживании, невозможно закрыть сервисную платформу и переключить версию。',
	['是否确认要覆盖已有的设定，储存新的设定？']: 'Вы уверены, что хотите заменить существующие настройки и сохранить новые настройки?',
	['已储存超过五个版本']: 'Сохранено более пяти версий',
	['版本已变动，是否需要储存？']: 'Версия изменилась, нужно сохранить?',
	['确定删除此版本？']: 'Вы действительно хотите удалить эту версию?',
	['编辑版本']: 'Редактировать версию',
	['侦测到重复联系客服系统，若非您本人请告知客服']: 'Обнаружена повторная связь с системой обслуживания клиентов. Если это не вы, пожалуйста, сообщите об этом оператору поддержки.',
	['删除此版本']: 'Удалить эту версию',
	['刪除成功']: 'Удаление успешно',
	['刪除失敗']: 'Удаление не удалось',
	['儲存成功']: 'Сохранено успешно',
	['儲存失敗']: 'Сохранение не удалось',
	['您好，请问要选择哪个问题？']: 'Здравствуйте, какой вопрос вы хотите выбрать?',
	['等待服务区']: 'Ожидание сервиса',
	['按时间排列(長到短)']: 'по времени (от длинного к короткому)',
	['按时间排列(短到長)']: 'По времени (от короткого к длинному)',
	['亲, 欢迎您的到来～很高兴为您服务，请先别著急，我们即将为您提供服务 ...']: 'Здравствуйте! Рады приветствовать вас. Пожалуйста, подождите немного, мы скоро вам ответим...',
	['编辑标签']: 'Редактировать метки',
	['于 {{time}} 侦测到会员【稍早已离线】']: 'Обнаружено членство 【недавно вышло в оффлайн】 на {{time}}.',
	['{{score}}分']: '{{score}} балл',
	['未评分']: 'Неоценённый',
	['客服完成']: 'Служба поддержки завершена',
	['会员离线']: 'Член оффлайн',
	['超时自动断线']: 'Автоматическое отключение при таймауте',
	['{{text}}不可重复']: '{{text}} нельзя повторять',
	['{{text}}不能为空']: '{{text}} не может быть пустым',
	['{{text}}设置错误']: 'Ошибка настройки {{text}}',
	['平均通话时长']: 'средняя продолжительность разговора',
	['平均通话数']: 'среднее количество звонков',
	['请选择角色名称']: 'Выберите имя персонажа',
	['请选择客服']: 'Пожалуйста, выберите службу поддержки',
	['请选择团队']: 'Пожалуйста, выберите команду',
	['播放']: 'воспроизвести',
	['统计时间']: 'статистическое время',
	['统计时间不可为空']: 'Время статистики не может быть пустым',
	['请输入时间']: 'Введите время',
	['时间筛选']: 'временной фильтр',
	['汇出']: 'экспорт',
	['未出勤']: 'Неявка',
	['客服平均通话时长']: 'средняя продолжительность разговора службы поддержки',
	['数量筛选']: 'количественный фильтр',
	['客服平均等待时间']: 'Среднее время ожидания обслуживания клиентов',
	['上一个月']: 'прошлый месяц',
	['导出Excel成功']: 'Экспорт Excel успешно завершен',
	['对话结束']: 'Диалог завершен',
	['满意度/客服']: 'Удовлетворение/служба поддержки',
	['日期/客服']: 'Дата/Клиентская служба',
	['总数']: 'Общее число',
	['日平均']: 'суточная средняя',
	['客服日均量']: 'среднее количество запросов в службу поддержки',
	['客服通话总量']: 'Общее количество звонков в службу поддержки',
	['日总量']: 'дневная норма',
	['请输入数量']: 'Введите количество',
	['满意度预设分数']: 'Оценка удовлетворенности',
	['当会员未评分，会自动给予此预设分数。']: 'Когда член не оценил, автоматически присваивается этот предустановленный балл.',
	['设定满意度预设分数成功']: 'Установка предустановленного балла удовлетворенности успешна',
	['客户满意度管理']: 'Управление удовлетворенностью клиентов',
	['对话结束方式']: 'Способ завершения диалога',
	['对话满意度']: 'Удовлетворенность диалогом',
	['时段']: 'период',
	['客服平均满意度']: 'Средняя удовлетворенность клиентов',
	['公用设定']: 'Общие настройки',
	['通话时长']: 'Длительность разговора',
	['服务时段']: 'период обслуживания',
	['储存时间']: 'время хранения',
	['客服不可为空']: 'Служба поддержки не может быть пустой',
	['团队不可为空']: 'Команда не может быть пустой',
	['请输入对话内容关键字']: 'Введите ключевые слова содержимого диалога',
	['请输入客服本名、昵称或帐号']: 'Введите настоящее имя, псевдоним или учетную запись службы поддержки',
	['平台不可为空']: 'Платформа не может быть пустой',
	['线上']: 'онлайн',
	['离线']: 'офлайн',
	['日期不可为空']: 'Дата не может быть пустой',
	['亲，跟您再次确认下，申请并进行此笔充值 {{chargeNumber}} 元的帐号是 {{chargeAccount}}，对吗？']: 'Дорогой, еще раз подтверждаю, что аккаунт для заявки и выполнения этого пополнения на {{chargeNumber}} юаней - {{chargeAccount}}, верно?',
	['您的等待顺位为第 {{pendingOrder}} 位']: 'Ваша очередь: № {{pendingOrder}}.',
	['拒絕由 {{inviter}} 转接至 {{invitee}}']: 'Отказ от передачи {{inviter}} к {{invitee}}',
	['{{name}} 已于 {{time}} 关闭视窗']: '{{name}} закрыл окно в {{time}}',
	['{{name}} 已于 {{time}} 点选案件完成']: '{{name}} завершил дело в {{time}}',
	['{{name}} 已于 {{time}} 成功加入协作']: '{{name}} успешно присоединился к сотрудничеству {{time}}',
	['{{name}} 已于 {{time}} 离开协作']: '{{name}} покинул(ла) сотрудничество в {{time}}',
	['{{name}} 已于 {{time}} 中断连线']: '{{name}} прервал соединение в {{time}}',
	['英文']: 'английский',
	['验证码设定']: 'Настройка验证码',
	['启用验证码']: 'Включить код подтверждения',
	['设定验证码成功']: 'Установка кода подтверждения прошла успешно',
	['启用验证码功能后，客户需完成验证才能进入客服系统等待区。']: 'После включения функции проверки кода клиент должен пройти проверку, чтобы войти в зону ожидания клиентской службы.',
	['禁止连续发话']: 'Не отправляйте сообщения слишком часто',
	['启用禁止连续发话']: 'Включить запрет на непрерывное выступление',
	['当会员在「限制秒数」内发话超过设定的次数，系统将会自动跳警告。']: 'Когда участник говорит больше установленного количества раз в течение «ограниченного времени», система автоматически выдаст предупреждение.',
	['客户端限制于']: 'клиентское ограничение на',
	['发话次数达到']: 'Количество высказываний достигло',
	['次']: '次 - раз',
	['暂时无法发话']: 'Временно не могу поговорить',
	['储存完成']: 'Сохранение завершено',
	['发送消息过于频繁 可稍后再试']: 'Слишком частые сообщения. Попробуйте позже.',
	['IP黑名单管理']: 'Управление черным списком IP',
	['共 {{total}} 笔']: 'Всего {{total}} сделок',
	['第 {{min}} - {{max}} 笔/共 {{total}} 笔']: 'Сделка {{min}} - {{max}} / всего {{total}} сделок',
	['顯示']: 'показать',
	['查询IP黑名单']: 'Запросить черный список IP',
	['设定自动添加黑名单']: 'Установить автоматическое добавление в черный список',
	['白名單管理']: 'Управление белым списком',
	['解除时间']: 'освобождение времени',
	['永久封锁']: 'постоянная блокировка',
	['新增IP黑名单']: 'Добавить IP-черный список',
	['加入黑名单后，该IP将无法进入客服前台。']: 'После добавления в черный список, этот IP не сможет получить доступ к клиентской панели.',
	['请完成安全验证']: 'Пожалуйста, завершите проверку безопасности',
	['向右滑动填充拼图']: 'Сдвиньте вправо, чтобы собрать пазл',
	['启用功能']: 'включить функцию',
	['若IP于「限制时间」内登入超过设定的「登入次数」系统即自动加入黑名单。']: 'Если IP входит в систему более установленного количества раз в "ограниченное время", он автоматически добавляется в черный список.',
	['限制时间']: 'ограничение времени',
	['时间单位不可为空']: 'Единица времени не может быть пустой',
	['时间单位']: 'единица времени',
	['登入次数']: 'Входы',
	['封锁时间']: 'блокировка времени',
	['锁的持续时间，时间到了会自动解除']: 'Длительность блокировки, по истечении времени она автоматически отменяется.',
	['查询IP白名单']: 'Запрос IP белого списка',
	['删除失败']: 'Удаление не удалось',
	['修改失败']: 'Ошибка изменения',
	['拼图验证失败次数过多']: 'Слишком много неудачных попыток верификации капчи',
	['{{name}} 已于 {{time}} 拒絕加入协作']: '{{name}} уже в {{time}} отказался присоединиться к сотрудничеству',
	['储存过滤模組成功']: 'Сохранение фильтрационного модуля успешно',
	['删除过滤模組成功']: 'Удаление фильтрующего модуля успешно',
	['解除谷歌验证成功']: 'Успешное отключение проверки Google',
	['确定禁用平台?']: 'Подтвердите отключение платформы?',
	['确定启用平台?']: 'Подтвердить активацию платформы?',
	['IP管理(客户端)']: 'Управление IP (клиент)',
	['上传']: 'загрузить',
	['此栏位的时间会使用于报表的团队筛选']: 'Время в этом поле будет использоваться для фильтрации команды в отчетах.',
	['选择团队：筛选出该团队所有客服人员在团队统计时间中的数据']: 'Выбор команды: отбор данных всех сотрудников службы поддержки в команде за время статистики команды',
	['备注最多{{inputLimit}}个字']: 'Примечание не более {{inputLimit}} символов',
	['{{inviter}} 已于 {{time}} 将对话从 {{from}} 转接给 {{invitee}}']: '{{inviter}} передал разговор от {{from}} к {{invitee}} в {{time}}',
	['小时']: 'час',
	['日']: 'день',
	['会员IP：{{ip}} 已加入前台黑名单']: 'Член IP: {{ip}} был добавлен в черный список на переднем плане',
	['新增失败']: 'Ошибка при добавлении',
	['会员IP被加入黑名单']: 'Членский IP был добавлен в черный список',
	['登入/接待时间']: 'Вход/время приема',
	['timePeriodTooltipMessage']: 'сообщениеToolTipпериодвремени',
	['平均接待时间']: 'среднее время ожидания',
	['平均登入时间']: 'Среднее время входа',
	['接待时间报表']: 'Отчет о времени приема',
	['登入时间报表']: 'Отчёт о времени входа',
	['未登入']: 'Неавторизованный',
	['设定报表']: 'Настройка отчета',
	['设定对话是否记入报表中']: 'Установить, записывать ли диалог в отчет.',
	['平均通话时长报表']: 'Средняя продолжительность разговора отчет',
	['平均通话数报表']: 'Среднее количество разговоров отчет',
	['平均等待时间报表']: 'Среднее время ожидания отчет',
	['客户满意度报表']: 'Отчет о удовлетворенности клиентов',
	['平均回覆时间报表']: 'Среднее время ответа отчет',
	['调整原因']: 'Причина корректировки',
	['请输入调整原因']: 'Введите причину изменения',
	['调整原因不可为空']: 'Причина коррекции не может быть пустой',
	['日期时间']: 'Дата и время',
	['操作人']: 'оператор',
	['原因']: 'причина',
	['更多']: 'больше',
	['收回']: 'отозвать',
	['设定报表成功']: 'Настройка отчета успешна',
	['平均回覆时间']: 'среднее время ответа',
	['客服平均回覆时间']: 'Среднее время ответа службы поддержки',
	['客户回头率']: 'Клиентская лояльность',
	['客户ID']: 'Идентификатор клиента',
	['客服帐号']: 'Служба поддержки',
	['小时回头率']: 'часовой коэффициент возврата',
	['日回头率']: 'дневной коэффициент возврата',
	['遗漏时间']: 'упущенное время',
	['请选择遗漏时间']: 'Пожалуйста, выберите пропущенное время',
	['平均遗漏时间']: 'среднее время пропуска',
	['1分钟']: '1 минута',
	['2分钟']: '2 минуты',
	['3分钟']: '3 минуты',
	['4分钟']: '4 минуты',
	['5分钟']: '5 минут',
	['离开时间']: 'время ухода',
	['客户回头率报表']: 'Отчет о коэффициенте возвращаемости клиентов',
	['平台报表']: 'платформенный отчет',
	['对话总量']: 'общее количество диалогов',
	['接待总量']: 'Общее количество приемов',
	['遗漏总量']: 'Общая сумма пропусков',
	['智能客服总量']: 'Общее количество интеллектуальных клиентских сервисов',
	['智能转客服总量']: 'Общее количество интеллектуальных переводов в службу поддержки клиентов',
	['最后更新时间']: 'Последнее обновление',
	['客服人数']: 'Номер службы поддержки клиентов',
	['在线客服总数']: 'Общее количество онлайн-поддержки',
	['等待服务']: 'Ожидание обслуживания',
	['正在服务']: 'В обслуживании',
	['智能未转客服总量']: 'Общее количество интеллектуальных непереведенных звонков в службу поддержки клиентов',
	['使用平台']: 'платформа',
	['泰文名称']: 'тайское название',
	['请输入泰文名称']: 'Введите тайское название',
	['英文名称']: 'английское название',
	['请输入英文名称']: 'Введите английское название',
	['中文名称']: '中文 название',
	['请输入中文名称']: 'Введите китайское название',
	['若无需翻译请填写中文']: 'Если не требуется перевод, пожалуйста, укажите китайский язык.',
	['帐号所有报表数据将连同帐号一同删除，请问确认要删除吗？']: 'Все отчетные данные аккаунта будут удалены вместе с аккаунтом. Подтверждаете удаление?',
	['停用']: 'остановить',
	['停用帐号']: 'Заблокировать аккаунт',
	['通话总数']: 'Общее количество звонков',
	['等待中人数：{{pendingConversationCount}} 人']: 'Ожидающих: {{pendingConversationCount}} человек',
	['报表正在汇出中，请前往页面「报表下载」查看进度并进行下载。']: 'Отчет сейчас экспортируется, пожалуйста, перейдите на страницу «Скачать отчет», чтобы проверить прогресс и скачать.',
	['汇出Load Data']: 'Выгрузить данные',
	['报表下载']: 'Скачать отчет',
	['全平台']: 'все платформы',
	['报表类型']: 'Тип отчета',
	['数据范围']: 'Диапазон данных',
	['汇出时间']: 'время экспорта',
	['完成时间']: 'время выполнения',
	['申请者']: 'заявитель',
	['下载']: 'Скачать',
	['重新汇出']: 'перепродажа',
	['处理中']: 'Обработка',
	['已完成']: 'Выполнено',
	['失败']: 'неудача',
	['下载成功']: 'Загрузка завершена',
	['历史对话纪录']: 'Исторический диалог записи',
	['连线中断，请点击确定尝试恢复连线，若无法恢复将结束对话。']: 'Соединение прервано, пожалуйста, нажмите ОК, чтобы попытаться восстановить соединение. Если восстановить не удастся, разговор будет завершен.',
	['引用功能管理']: 'Управление функцией цитирования',
	['引用对话']: 'Цитировать диалог',
	['设定引用对话成功']: 'Настройка цитирования диалога успешна',
	['客户管理']: 'Управление клиентами',
	['重要客户帐号']: 'важный клиентский аккаунт',
	['请输入重要客户帐号、备注等关键字']: 'Введите важные учетные данные клиента, заметки и другие ключевые слова',
	['新增重要客户']: 'Добавить важного клиента',
	['重要客户帐号不能为空']: 'Важный клиентский аккаунт не может быть пустым',
	['输入多个帐号请用, 区隔']: 'Введите несколько аккаунтов, разделяя запятой',
	['修改重要客户']: 'Изменить важного клиента',
	['重要帐号']: 'важная учетная запись',
	['会员类型']: 'Тип членства',
	['引用']: 'Цитата',
	['收回(訊息)']: 'отозвать (сообщение)',
	['收回功能管理']: 'Отзыв функции управления',
	['收回提示文字不能为空']: 'Возврат сообщения не может быть пустым',
	['收回对话']: 'Отозвать разговор',
	['收回提示文字（中文）']: 'Отозвать текст подсказки',
	['收回提示文字（英文）']: 'отозвать подсказку (по-английски)',
	['收回提示文字（泰文）']: 'Отозвать текст подсказки (тайский)',
	['视频']: 'видео',
	['确定要收回讯息吗？']: 'Вы уверены, что хотите отозвать сообщение?',
	['设定收回功能成功']: 'Настройка функции отзыва прошла успешно',
	['遗漏数据']: 'пропущенные данные',
	['全选']: 'Выбрать все',
	['请选择使用平台']: 'Выберите платформу использования',
	['日期计算方式']: 'способ расчёта дат',
	['以会员进入正在服务区的时间计算']: 'По времени входа члена в обслуживаемую зону',
	['以会员进入等待服务区的时间计算，若是点击智能客服未进入等待服务区则以点入智能客服的时间计算']: 'Для расчёта используется время, затраченное на вход в зону ожидания. Если участник нажимает на кнопку смарт-обслуживания, но не входит в зону ожидания, для расчёта используется время, затраченное на вход в зону смарт-обслуживания.',
	['以会员进入等待服务区的时间计算']: 'Расчет времени ожидания обслуживания для членов.',
	['以客服接通对话的时间进行计算']: 'Исходя из времени, когда служба поддержки подключает разговор',
	['以会员进入等待服务区的时间进行计算']: 'Согласно времени ожидания обслуживания для членов.',
	['以会员点击智能客服的时间计算']: 'По времени, когда участник нажимает на интеллектуального помощника.',
	['相同类型才会计算回头']: 'Однотипные будут рассчитывать возврат.',
	['登入联系离开后再次登入联系']: 'Войдите свяжитесь снова после выхода войдите свяжитесь',
	['一通对话只会触发一次回头次数']: 'Одно сообщение вызовет только один раз количество поворотов.',
	['同一会员时间内连续联系3次，计算前两通对话的客服各1次回头']: 'В течение одного и того же периода членства, если осуществить три последовательных контакта, учитываются по одному обращению в службу поддержки для первых двух бесед.',
	['每日同一会员于对话结束后{{hour}}小时内又重复联系的有效对话比例']: 'Доля эффективных диалогов, в которых один и тот же участник повторно связывается в течение {{hour}} часов после окончания разговора.',
	['未登入联系离开后再次未登入联系']: 'Неавторизованный контакт, покинувший после повторного неавторизованного контакта',
	['请输入重要客户帐号']: 'Введите учетную запись важного клиента',
	['开始日期']: 'Дата начала',
	['结束日期']: 'дата окончания',
	['标签名称/数量']: 'Название/Количество',
	['暂无数据']: 'Нет данных',
	['AI客服设定']: 'Настройки AI-поддержки',
	['AI共同设定']: 'Совместное задание ИИ',
	['平台AI设定']: 'Платформа AI настройки',
	['平台 AI SKILL 设定']: 'Платформа AI SKILL настройки',
	['指令输入说明']: 'Инструкция по вводу команд',
	['输入文字档']: 'ввод текстового файла',
	['不需要区分功能']: 'Не нужно различать функции',
	['套用平台']: 'применяемая платформа',
	['请输入指令']: 'Введите команду',
	['AI与会员对话超过 <<inputNumber>> 轮后需要通知客服人员']: 'После более <<inputNumber>> раундов общения ИИ с членами необходимо уведомить службу поддержки.',
	['指令']: 'команда',
	['AI开关']: 'AI переключатель',
	['AI客服名称']: 'Имя AI-ассистента',
	['AI客服名称不能为空']: 'Имя AI-оператора не может быть пустым',
	['请输入AI客服名称']: 'Введите имя AI-менеджера',
	['是否要关闭AI客服？关闭后将无法再度开启AI客服']: 'Вы хотите отключить AI-ассистента? После отключения вы не сможете снова включить AI-ассистента.',
	['侦测到对话有异常状态，请尽快处理']: 'Обнаружено аномальное состояние диалога, пожалуйста, обработайте как можно скорее.',
	['需要转接人工客服，请尽快处理']: 'Необходимо подключить оператору, пожалуйста, обработайте как можно быстрее.',
	['总平均通话时长']: 'Средняя продолжительность разговора',
	['AI平均通话时长']: 'AI среднее время разговора',
	['人工平均通话时长']: 'Средняя продолжительность телефонного разговора',
	['每日总平均']: 'ежедневная средняя',
	['AI日平均']: 'AI среднее за день',
	['人工日平均']: 'штучный среднедневной',
	['通话总量']: 'Общее количество звонков',
	['AI通话总量']: 'Общее количество AI-звонков',
	['共同']: 'совместный',
	['总计']: 'итого',
	['总计请勿超过{{limit}}字']: 'Общая сумма не должна превышать {{limit}} знаков.',
	['总平均回覆时间']: 'Среднее время ответа',
	['AI平均回覆时间']: 'Среднее время ответа ИИ',
	['人工平均回覆时间']: 'Среднее время ответа человека',
	['AI日总量']: 'AI дневной объем',
	['人工日总量']: 'искусственное количество солнечного света',
	['指令不能为空']: 'Команда не может быть пустой',
	['{{name}} 已于 {{time}} 开启AI']: '{{name}} уже в {{time}} запустил AI',
	['{{name}} 已于 {{time}} 关闭AI']: '{{name}} закрыл AI {{time}}',
	['人机合作日总量']: 'Число сотрудничества человека и машины в день',
	['人工通话总量']: 'Общее количество人工通话',
	['人机合作通话总量']: 'Число разговоров человеко-машинного сотрудничества',
	['以对话建立时间计算']: 'Установить время по диалогу',
	['侦测到对话有异常状态 - 对话次数超过限制']: 'Обнаружена ошибка диалога — Превышен лимит сообщений',
	['侦测到对话有异常状态 - 系统发生错误']: 'Обнаружена ошибка диалога — Системная ошибка',
	['人机合作-人工日平均']: 'Человеко-компьютерное сотрудничество - искусственный средний дневной',
	['人机合作-AI日平均']: 'Человеко-машинное сотрудничество - среднее значение ИИ в день',
	['人机合作-人工平均通话时长']: 'Человеко-машинное сотрудничество - средняя продолжительность разговора с ИИ',
	['人机合作-AI平均通话时长']: 'Человеко-машинное сотрудничество - средняя продолжительность разговора ИИ',
	['侦测到对话有异常状态 - 等待AI API超过两分钟']: 'Обнаружена ошибка диалога — Ожидание ответа AI API более 2 минут',
	['侦测到对话有异常状态 - AI 发生错误']: 'Обнаружена ошибка диалога — Ошибка AI',
	['侦测到对话有异常状态 - AI 没有回复']: 'Обнаружена ошибка диалога — Нет ответа от AI',
	['数据']: 'данные',
	['指令不能超过{{limit}}字']: 'Команда не может превышать {{limit}} символов',
	['数据不能为空']: 'Данные не могут быть пустыми',
	['数据不能超过100万字']: 'Данные не могут превышать 1 миллион слов',
	['需{{limit}}字以内']: 'нужно до {{limit}} знаков',
	['数据输入说明']: 'Инструкция по ввод данных',
	['需100万字以内']: 'не должно превышать 1 миллиона слов',
	['至少要有一组 ~~~~~ 与 =====']: 'Должно содержать хотя бы одну пару ~~~~~ и =====',
	['分隔符号 ~~~~~ 与 ===== 需成对出现']: 'Разделители ~~~~~ и ===== должны использоваться парами',
	['需以 ===== 结尾']: 'Должно заканчиваться на =====',
	['标题底下使用5个波浪号并换行，波浪号的开头与结尾不能有其他文字或空格']: 'Поставьте 5 тильд в строке под заголовком, без других символов или пробелов до и после них',
	['内容底下使用5个等号并换行，等号的开头与结尾不能有其他文字或空格']: 'Поставьте 5 знаков равенства в строке под содержимым, без других символов или пробелов до и после них',
	['范例']: 'Пример',
	['标题A（可多行）']: 'Заголовок A (можно несколько строк)',
	['内容A（可多行，可含任何文字）']: 'Содержимое A (несколько строк, любой текст)',
	['标题B（可多行）']: 'Заголовок B (можно несколько строк)',
	['内容B（可多行，可含任何文字）']: 'Содержимое B (несколько строк, любой текст)',
	['模型顺序（上方模型优先使用，失效时自动往下切换）']: 'Порядок моделей (верхняя модель используется первой; при сбое автоматически переключается на следующую)',
	['主要']: 'Основной',
	['备援{{index}}']: 'Резервный {{index}}',
	['新增备援模型']: 'Добавить резервную модель',
	['请输入数据']: 'Введите данные',
	['正在转接中...']: 'Перенаправление...',
	['（中文）']: '(中文)',
	['（英文）']: '(английский)',
	['（泰文）']: 'Тайский',
	['（越南文）']: 'вьетнамский язык',
	['越南文名称']: 'вьетнамский язык',
	['请输入越南文名称']: 'Введите название на вьетнамском языке',
	['模式']: 'модель',
	['越南语']: 'вьетнамский',
	['IP白名单设定']: 'Настройка белого списка IP',
	['建立时间']: 'время создания',
	['批次删除']: '批次删除 在俄語中是 "пакетное удаление"',
	['请确认是否删除 IP 白名单？']: 'Пожалуйста, подтвердите, хотите ли вы удалить белый список IP?',
	['开启快捷选单']: 'Открыть быстрое меню',
	['收合快捷选单']: 'Свернуть быстрое меню',
	['是否有收回人员讯息']: 'Есть ли информация о возврате сотрудников?',
	['是否有收回AI讯息']: 'Есть ли возможность отозвать AI-сообщение?',
	['消息已被客服撤回']: 'Сообщение было отозвано службой поддержки.',
	['用户快捷选单管理']: 'Управление быстрым меню пользователя',
	['电脑预览']: 'Компьютерный предварительный просмотр',
	['手机预览']: 'мобильный просмотр',
	['档案格式：PNG、JPG、JPEG']: 'Формат файла: PNG, JPG, JPEG',
	['请选择上传档案']: 'Пожалуйста, выберите файл для загрузки',
	['新增快捷成功']: 'Добавление ярлыка успешно завершено',
	['修改快捷成功']: 'Изменение успешно выполнено',
	['设定快捷选单成功']: 'Успех настройки быстрого меню',
	['删除快捷成功']: 'Удаление выполнено успешно',
	['确定删除此快捷？']: 'Вы уверены, что хотите удалить этот ярлык?',
	['新增内容']: 'Добавить контент',
	['选项內容']: 'вариант содержимого',
	['{{itemLabel}}內容不能为空']: '{{itemLabel}} не может быть пустым',
	['请输入{{itemLabel}}标题']: 'Введите заголовок {{itemLabel}}',
	['请输入{{itemLabel}}选项']: 'Пожалуйста, введите вариант {{itemLabel}}',
	['{{text}}不可为空']: '{{text}} не может быть пустым',
	['显示更多']: 'Показать больше',
	['公告标签']: 'объявление标签',
	['请选择公告标签']: 'Выберите метку объявления',
	['{{text}}标题']: '{{text}} заголовок',
	['{{text}}內文']: '{{text}} внутреннее содержание',
	['{{text}}最多{{inputLimit}}个字']: '{{text}} не более {{inputLimit}} символов',
	['公告内文档案大小总计不得大于10MB']: 'Общий размер документов в уведомлении не должен превышать 10 МБ.',
	['用户尚未离开，确认要完成对话？']: 'Пользователь еще не вышел, подтверждаете завершение разговора?',
	['{{name}} 已于 {{time}} 离开对话']: '{{name}} покинул(а) разговор {{time}}.',
	['客服人员']: 'Специалист по обслуживанию клиентов',
	['*新增多个IP请使用逗号「 , 」隔开']: 'Для добавления нескольких IP, пожалуйста, используйте запятую «,» для разделения.',
	['是否新增IP白名单？']: 'Добавить белый список IP?',
	['IP已存在']: 'IP уже существует',
	['监控区管理']: 'Управление зоной мониторинга',
	['监控区开关']: 'Переключатель зоны мониторинга',
	['设定监控区开关成功']: 'Переключатель зоны мониторинга успешно настроен.',
	['启用功能后，等待服务区会增加一个[监控区]页签，显示全平台被AI拦截的对话与未读时间最长的5通对话，点击可快速跳转至相应对话。']: 'После активации функции в зоне ожидания появится вкладка [Зона мониторинга], отображающая перехваченные ИИ диалоги по всей платформе и 5 непрочитанных диалогов с самым длительным временем. Нажмите, чтобы быстро перейти к соответствующему диалогу.',
	['{{name}} 新增了标签 {{tag}}']: '{{name}} добавил тег {{tag}}',
	['{{name}} 移除了标签 {{tag}}']: '{{name}} удалил тег {{tag}}',
	['状态切换为暂离']: 'Состояние переключено на временное отсутствие',
	['状态切换为工作中']: 'Состояние переключено на "в работе"',
	['监控区']: 'Зона мониторинга',
	['自动接线管理']: 'Автоматическое управление соединениями',
	['客服全平台接待数量达到上限后，系统不会自动接入等待服务区的对话，客服人员手动接入数量不限制。']: 'Количество обращений в службу поддержки на всех платформах достигло максимума, система не будет автоматически подключать диалоги в зоне ожидания, количество ручных подключений сотрудников службы поддержки не ограничено.',
	['自动接线数量上限']: 'Максимальное количество автоматических соединений',
	['设定自动接线成功']: 'Установлен автоматический ответ成功',
	['{{name}} 进线']: '{{name}} Входящий',
	['工作/暂离时间']: 'Работа/время отсутствия',
	['工作时长报表']: 'Отчет о продолжительности работы',
	['暂离时长报表']: 'Временной отчет о временном отсутствии',
	['平均工作时长']: 'средняя продолжительность рабочего времени',
	['平均暂离时长']: 'средняя продолжительность временного отсутствия',
	['关键字提醒']: 'ключевое слово напоминание',
	['客户发话']: 'Клиент говорит',
	['AI发话']: 'Искусственный интеллект высказался',
	['发话来源']: 'источник речи',
	['请输入发话来源、关键字']: 'Введите источник речи, ключевое слово',
	['新增关键字']: 'Добавить ключевое слово',
	['修改关键字']: 'Изменить ключевое слово',
	['新增关键字成功']: 'Добавление ключевого слова прошло успешно',
	['修改关键字成功']: 'Изменение ключевого слова успешно',
	['删除关键字成功']: 'Удаление ключевого слова прошло успешно',
	['是否删除此关键字？']: 'Удалить этот ключевое слово?',
	['请用「；」来分隔不同关键字，关键字不得超过100个字']: 'Пожалуйста, используйте «;» для разделения различных ключевых слов, ключевые слова не должны превышать 100 слов.',
	['客户触发关键字 [{{word}}] 请客服人员注意']: 'Клиент активировал ключевое слово [{{word}}] Обратите внимание на сотрудников службы поддержки.',
	['AI触发关键字 [{{word}}] 请客服人员注意']: 'AI-триггер ключевое слово [{{word}}] Обратите внимание, пожалуйста, служба поддержки.',
	['请输入通知时间']: 'Введите время уведомления',
	['自动接线开关']: 'Автоматический выключатель',
	['自动接线数量上限不可为空']: 'Максимальное количество автоматических соединений не может быть пустым',
	['请输入数量上限']: 'Введите верхний предел количества',
	['离开状态侦测开关']: 'Кнопка отключения состояния детектора',
	['开启后当客服人员为平台最后一个工作状态或仍有接待中且无协作给他人对话时，无法切换为离开状态。']: 'После активации, когда сотрудник службы поддержки находится в последнем рабочем состоянии платформы или продолжает общение и не передал диалог другим, он не может переключиться в состояние "выйти".',
	['离开时间通知开关']: 'Уведомление о времени ухода переключатель',
	['通知时间不可重复']: 'Время уведомления не может повторяться',
	['侦测权限CS帐号离开时间，离开时间达设定时间时通知权限manager以上的帐号，以及触发离开时间的CS帐号本人。']: 'Обнаружение времени выхода аккаунта CS с правами, уведомление аккаунтов уровня manager и выше, когда время выхода достигает установленного времени, а также уведомление самого аккаунта CS, который инициировал выход.',
	['最后暂离时间报表']: 'Последний отчет о времени отсутствия',
	['平均最后暂离时间']: 'Среднее время последнего выхода',
	['{{name}} 离开时间已达 [{{minute}}] 分钟 !']: '{{name}} время ухода достигло [{{minute}}] минут!',
	['历史对话记录下载']: 'Историческая запись диалога скачать',
	['使用模式']: 'Использовать шаблон',
	['标准模式']: 'Стандартный режим',
	['ID模式']: 'ID-режим',
	['即进模式']: 'аварийный режим',
	['复制即进网址']: 'Копируйте и переходите по адресу',
	['生成新网址']: 'Сгенерировать новый адрес веб-сайта',
	['需提供客户Profile资料的标准模式，此模式为系统预设模式。']: 'Требуется предоставить стандартный шаблон профиля клиента, этот шаблон является предустановленным шаблоном системы.',
	['输入ID 进入客服，可不提供客戶Profile资料。']: 'Введите ID для входа в службу поддержки, не предоставляя профиль клиента.',
	['透过即进网址可直接进入客服系统，无需提供资料，系统自动给予随机访客名称。']: 'Вы можете войти в систему обслуживания клиентов напрямую через мгновенный URL-адрес, не предоставляя никакой информации. Система автоматически присвоит посетителю случайное имя.',
	['请再次确认是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]']: 'Пожалуйста, подтвердите еще раз, переключились ли вы с [<<prevTypeText>>] на [<<nextTypeText>>].',
	['以下是即进网址']: 'Следующий адрес сайта',
	['复制网址']: 'Скопировать URL',
	['使用模式切换成功']: 'Успешное переключение режимов',
	['请再次确认是否更换网址 ，一经更换<<redText>>']: 'Пожалуйста, еще раз подтвердите, заменили ли вы адрес веб-сайта, после замены <<redText>>.',
	['当前即进网址']: 'Текущий адрес сайта',
	['新即进网址']: 'Новый сайт',
	['复制即进网址成功']: 'Копирование успешного перехода по ссылке',
	['报表统计']: 'отчет статистики',
	['操作時間']: 'время операции',
	['统计类型']: 'статистический тип',
	['请选择统计类型']: 'Выберите тип статистики',
	['查询参数']: 'параметры запроса',
	['申请时间']: 'время подачи',
	['产出时间']: 'время производства',
	['申请帐号']: 'заявка на аккаунт',
	['详细资料']: 'подробности',
	['重新执行统计']: 'Повторное выполнение статистики',
	['执行统计']: 'Выполнение статистики',
	['登入时间范围']: 'Время входа',
	['选择团队：筛选出该团队所有客服人员']: 'Выбор команды: отбор всех сотрудников службы поддержки этой команды',
	['API接收日志']: 'API прием журналов',
	['新增来源']: 'Добавить источник',
	['CS']: 'КС',
	['包网']: 'пакетная сеть',
	['包网API']: 'пакетный API',
	['第 {{min}} - {{max}} 笔']: 'Сейчас {{min}} - {{max}} запись',
	['选择的日期区间需小于等于{{limit}}天']: 'Выбранный диапазон дат должен быть меньше или равен {{limit}} дням.',
	['请选择日期时间查询条件']: 'Пожалуйста, выберите условия для поиска даты и времени.',
	['类型']: 'тип',
	['公司']: 'компания',
	['请输入公司']: 'Введите компанию',
	['会员帐号']: 'учетная запись участника',
	['请输入会员帐号']: 'Введите учетную запись члена',
	['是否查看详细资料？']: 'Хотите посмотреть подробности?',
	['传送资料']: 'Передача данных',
	['CS回覆资料']: 'CS ответные данные',
	['内容']: 'содержание',
	['请选择进入的公司']: 'Пожалуйста, выберите компанию для входа.',
	['指令数据更新纪录']: 'Журнал обновления данных команд',
	['1.排序机制：所有公司的指令将统一排序处理，确保系统高效运作。']: '1. Механизм сортировки: все команды компаний будут обрабатываться в едином порядке, что обеспечит эффективную работу системы.',
	['2.数据隔离：用户仅能查看自己公司的更新记录，无法查看其他公司的记录。']: '2. Изоляция данных: Пользователь может видеть только обновления своей компании и не может видеть записи других компаний.',
	['微调训练']: 'дообучение',
	['执行微调']: 'выполнить дообучение',
	['操作帐号']: 'Операционная учетная запись',
	['是否修改AI API?']: 'Изменить API ИИ?',
	['保存设置']: 'Сохранить настройки',
	['修改AI API成功']: 'Изменение API ИИ успешно',
	['请输入{{text}}']: 'Введите {{text}}',
	['{{text}}不能超过{{limit}}字元']: '{{text}} не может превышать {{limit}} символов',
	['AI API']: 'ИИ API',
	['微调训练记录']: 'Тонкая настройка истории обучения',
	['模型名称']: 'название модели',
	['新增文本']: 'Добавить текст',
	['修改文本']: 'Изменить текст',
	['请输入名称']: 'Введите имя',
	['取消修改微调文本']: 'Отменить изменение текста настройки',
	['角色不可为空']: 'Роль не может быть пустой',
	['请选择角色']: 'Выберите персонажа',
	['内容不可为空']: 'Содержимое не может быть пустым',
	['请输入内容']: 'Введите содержимое',
	['系统']: 'система',
	['会员']: 'участник',
	['AI']: 'ИИ',
	['请确认是否取消？']: 'Пожалуйста, подтвердите, отменить ли?',
	['新增微调文本成功']: 'Успешное добавление текстовой доработки',
	['修改微调文本成功']: 'Успешно изменённый текст настройки',
	['自定模型名称']: 'Настройка имени модели',
	['微调确认讯息']: 'Подтверждение настроек',
	['请确认是否执行微调训练？']: 'Пожалуйста, подтвердите, выполнять ли тонкую настройку?',
	['删除微调文本']: 'Удалить текст настройки',
	['请确认是否刪除？']: 'Пожалуйста, подтвердите, хотите ли вы удалить?',
	['刪除微调文本成功']: 'Удаление текста тонкой настройки прошло успешно',
	['请输入模型名称']: 'Введите название модели',
	['执行微调成功']: 'Успешно выполнена настройка',
	['取消修改文本成功']: 'Отмена изменения текста прошла успешно',
	['取消新增文本成功']: 'Отмена успешна',
	['您已成功登出客服系统。']: 'Вы успешно вышли из системы обслуживания клиентов.',
	['如需重新登录，请返回包网！']: 'Если вам нужно войти снова, пожалуйста, вернитесь на пакетный сайт!',
	['您已成功登出客服系统管理端。']: 'Вы успешно вышли из системы управления клиентской службой.',
	['当「平均等待时间」显示为 0 秒时，可能的原因如下：']: 'Когда "среднее время ожидания" отображается как 0 секунд, возможные причины следующие:',
	['1.当日所有对话的等待时间均为 0 秒（例如因自动接线或即时应答，无需等待）。']: 'Время ожидания всех диалогов в тот день составляет 0 секунд (например, из-за автоматического ответа или мгновенного реагирования, ожидание не требуется).',
	['2.根据公式 「每日总等待时间 ÷ 每日对话数量」，计算结果经四舍五入后为 0 秒。']: '2.По формуле «Общее время ожидания в день ÷ Количество диалогов в день» результат, округленный, составляет 0 секунд.',
	['系统显示为 「未登入」 时，表示该帐号在其设定的团队时间内未产生任何对话数据。']: 'Система отображает «Не вошел в систему», что означает, что этот аккаунт не создал никаких данных о диалогах в установленное время команды.',
	['加入微调']: 'Присоединиться к донастройке',
	['启用API Key']: 'Включить API ключ',
	['微调汇入对话记录']: 'Небольшая настройка ввода диалоговых записей',
	['对话数量']: 'Количество диалогов',
	['文本最后角色需为AI或客服人员']: 'В конце текста роль должна быть AI или сотрудника службы поддержки.',
	['汇入微调文本']: 'Импортируемый текст настройки',
	['檔案格式：CSV，且档案大小不得大于']: 'Формат файла: CSV, и размер файла не должен превышать',
	['文本最后角色需为AI或客服人员，请修改后再进行汇出或执行微调']: 'В конце текста роль должна быть AI или сотрудника службы поддержки, пожалуйста, измените перед экспортом или выполнением доработки.',
	['批量加入微调']: 'Пакетное добавление доработки',
	['自定加入微调的名称']: 'Название для настройки под себя',
	['微调名称']: 'Название тонкой настройки',
	['请输入微调的名称']: 'Введите название донастройки',
	['微调的名称']: 'Название донастройки',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔']: 'Пожалуйста, подтвердите, хотите ли вы удалить выбранные записи (всего {{selectedFineTuningRecordsLength}} штук).',
	['已取消']: 'Отменён',
	['取消微调']: 'Отменить донастройку',
	['取消微调成功']: 'Отмена настройки успешно выполнена',
	['取消此笔客服系统微调训练时，需要同时取消对应的 OpenAI 后台微调训练。只有两者均取消后，微调训练才会被完整移除。请确认是否要取消此客服系统微调训练？']: 'Чтобы отменить настройку обучения клиентской службы, необходимо одновременно отменить соответствующую настройку обучения на стороне OpenAI. Только после отмены обоих настроек обучение будет полностью удалено. Пожалуйста, подтвердите, хотите ли вы отменить эту настройку обучения клиентской службы?',
	['复制快捷语成功']: 'Копирование быстрого языка выполнено успешно',
	['复制常用图片成功']: 'Копирование часто используемых изображений прошло успешно',
	['左侧']: 'левый',
	['右侧']: 'правый бок',
	['{{text}}正在服务{{total}}则对话']: '{{text}} обслуживает {{total}} диалогов',
	['新增跑马灯成功']: 'Добавление бегущей строки прошло успешно',
	['修改跑马灯成功']: 'Изменение бегающего текста успешно',
	['刪除跑马灯成功']: 'Удаление бегущей строки успешно',
	['启用跑马灯成功']: 'Включение бегущей строки прошло успешно',
	['停用跑马灯成功']: 'Успешно отключен бегущий текст',
	['对象栏位']: 'объектный столбец',
	['显示跑马灯内容']: 'Показать содержимое бегущей строки',
	['请确认是否启用跑马灯？']: 'Пожалуйста, подтвердите, следует ли включить бегущую строку?',
	['请确认是否停用跑马灯？']: 'Пожалуйста, подтвердите, хотите ли вы отключить бегущую строку?',
	['请确认是否删除跑马灯？']: 'Пожалуйста, подтвердите, хотите ли вы удалить бегущую строку?',
	['{{text}}最多{{inputLimit}}组']: '{{text}} максимум {{inputLimit}} групп',
	['数值范围']: 'диапазон значений',
	['数值不能为空']: 'Значение не может быть пустым',
	['数值']: 'числовое значение',
	['请输入数字']: 'Введите число',
	['输入多组文字请用, 区隔']: 'Введите несколько наборов текста, пожалуйста, разделите запятыми.',
	['当用户符合对象设定名称及栏位规则中的内容时，才会生效跑马灯推广']: 'Когда пользователь соответствует установленному имени объекта и правилам полей, тогда будет действовать пробегающее рекламное сообщение.',
	['新增跑马灯']: 'Добавить бегущую строку',
	['对象栏位不能为空']: 'Поле объекта не может быть пустым',
	['请输入对象栏位']: 'Введите поле объекта',
	['栏位规则']: 'Правила столбцов',
	['栏位规则不能为空']: 'Правила столбца не могут быть пустыми',
	['请选择栏位规则']: 'Пожалуйста, выберите правила столбцов',
	['开头图示']: 'начальная иллюстрация',
	['开头图示不能为空']: 'Начальный рисунок не может быть пустым',
	['请选择开头图示']: 'Выберите изображение в начале',
	['跑马灯内容']: 'бегущая строка',
	['修改跑马灯']: 'изменить бегущую строку',
	['变更的平台设定将同步套用至下级角色，是否确认修改？']: 'Изменения платформенных настроек будут применены к подчиненным ролям,确认修改？',
	['确认要删除[个人/公共]常用图片[{{title}}]吗？']: 'Вы действительно хотите удалить [личное/публичное] часто используемое изображение [{{title}}]?',
	['一经确认删除无法复原。']: 'После подтверждения удаления восстановить не получится.',
	['客服日志']: 'Журнал обслуживания клиентов',
	['请输入内容等关键字']: 'Введите содержание и ключевые слова',
	['确认要删除[个人/公共]快捷语[{{title}}]：[{{content}}]吗？']: 'Вы уверены, что хотите удалить [личный/общий] быстрый элемент [{{title}}]: [{{content}}]?',
	['没有其他进入标签被开启，故无法关闭此进入标签']: 'Не открывалась другая вкладка, поэтому нельзя закрыть эту вкладку.',
	['没有其他进入标签被开启，故无法删除此标签']: 'Нет других активированных тегов, поэтому удалить этот тег невозможно。',
	['所有人']: 'все',
	['自定义对象']: 'Пользовательский объект',
	['套用对象']: 'Объект применения',
	['回主画面']: 'На главную',
	['孟加拉语']: 'бенгальский',
	['繁体中文']: 'традиционный китайский',
	['简体中文']: 'упрощенный китайский',
	['韩语']: 'корейский',
	['日语']: 'японский',
	['葡萄牙语']: 'португальский язык',
	['印地语']: 'хинди',
	['俄语']: 'Русский',
	['重要资讯']: 'важная информация',
	['在对话中切换语言，在某些情况下，可能导致讯息翻译功能延迟约 10 分钟，影响新旧讯息的读取。确定要切换语言?']: 'В процессе разговора переключение языка в некоторых случаях может привести к задержке функции перевода сообщений примерно на 10 минут, что повлияет на чтение новых и старых сообщений. Вы уверены, что хотите переключить язык?',
	['暂无对话']: 'Нет диалога',
	['档案上传中']: 'Загрузка файла',
	['{{name}} 已于 {{time}} 开启自动推播']: '{{name}} сейчас включил автоматическую рассылку в {{time}}',
	['{{name}} 已于 {{time}} 关闭自动推播']: '{{name}} отключил автоматическую рассылку в {{time}}',
	['商户代码']: 'Код мерчанта',
	['请输入商户代码']: 'Введите код мерчанта',
	['密钥']: 'Секретный ключ',
	['请输入密钥']: 'Введите секретный ключ',
	['共同设定']: 'Общие настройки',
	['充值未到帐设定']: 'Настройки незачисленного пополнения',
	['出款未到帐设定']: 'Настройки незачисленного вывода',
	['确认进行储存？']: 'Подтвердить сохранение?',
	['SKILL开关']: 'Переключатель SKILL',
	['请输入SKILL']: 'Введите SKILL',
	['派单 API 参数']: 'Параметры API назначения заказа',
	['请输入派单API URL']: 'Введите URL API назначения заказа',
	['开单者username']: 'Имя пользователя создателя заказа',
	['请输入开单者username']: 'Введите имя пользователя создателя заказа',
	['频道名称']: 'Название канала',
	['请输入频道名称']: 'Введите название канала',
	['开单原因']: 'Причина создания заказа',
	['请输入开单原因']: 'Введите причину создания заказа',
	['充值订单查询 API URL']: 'URL API запроса заказа на пополнение',
	['出款订单查询 API URL']: 'URL API запроса заказа на вывод',
	['同义词设定']: 'Синонимы',
	['开启BM25']: 'Включить BM25',
	['同义词']: 'синонимы',
	['更新时间']: 'Время обновления',
	['批次新增同义词']: 'Пакетное добавление синонимов',
	['修改同义词']: 'изменить синоним',
	['新增同义词']: 'Добавить синонимы',
	['请输入同义词，使用逗号区隔不同词汇']: 'Введите синонимы, разделяя разные слова запятыми.',
	['请以逗号区隔不同词汇，用分号区隔不同组同义词']: 'пожалуйста, используйте запятую для отделения разных слов и точку с запятой для отделения разных групп синонимов',
	['输入格式说明：']: 'Вводный формат说明：',
	['请用，区隔不同词汇，例如：充值,储值,入金,课金']: 'пополнение, накопление, депозит, финансирование',
	['词汇与标点符号前后不要出现空白']: 'Словарные единицы и знаки препинания не должны иметь пробелов перед и после.',
	['请用；或分行(enter)区隔同组同义词，例如：']: 'Пожалуйста, используйте ; или разделяйте однокоренные синонимы в одной группе (enter), например:',
	['充值,储值,入金,课金']: 'пополнение',
	['log in,登入;亲,宝贝']: 'войти, друг',
	['请输入同义词']: 'Введите синонимы',
	['同义词不可为空']: 'Синонимы не могут быть пустыми',
	['同义词格式有误']: 'Формат синонимов неверен',
	['同义词不可有特殊字元']: 'Синонимы не могут содержать специальные символы',
	['字元不可超过10000']: 'Символы не могут превышать 10000',
	['需至少输入两个词汇']: 'Необходимо ввести как минимум два слова',
	['删除同义词']: 'Удалить синонимы',
	['请确认是否删除同义词？']: 'Пожалуйста, подтвердите, хотите ли вы удалить синонимы?',
	['新增同义词成功']: 'Добавление синонима прошло успешно',
	['新增同义词失败']: 'Не удалось добавить синонимы',
	['修改同义词成功']: 'Успешно изменено синонимы',
	['修改同义词失败']: 'Не удалось изменить синонимы',
	['删除同义词成功']: 'Удаление синонима прошло успешно',
	['删除同义词失败']: 'Не удалось удалить синоним.',
	['内容有重复字']: 'Содержимое содержит повторяющиеся слова',
	['新增图片，详细图片请参考公告管理']: 'Добавить изображение, для подробных изображений смотрите управление объявлениями.',
	['目前只支援ChatGPT进行微调训练']: 'В данный момент поддерживается только дообучение ChatGPT.',
	['AI系列']: 'Серия AI',
	['AI系列不能为空']: 'Серия AI не может быть пустой',
	['启用ChatGPT']: 'Включить ChatGPT',
	['启用Gemini']: 'Включить Gemini',
	['AI客服']: 'ИИ-поддержка',
	['ID入口']: 'ID вход',
	['IP']: 'ИП',
	['USER ID']: 'Пользовательский идентификатор',
	['{{itemLabel}}內容不可为空']: 'Содержимое {{itemLabel}} не может быть пустым',
	['{{text}}仅能输入数字']: '{{text}}можно вводить только цифры',
	['{{text}}最多{{limit}}个字元']: '{{text}} не более {{limit}} символов',
	['{{text}}最多數字{{limit}}碼']: '{{text}} максимум {{limit}} цифр',
	['{{time}}分']: '{{time}} минут',
	['{{time}}时']: '{{time}} часов',
	['{{time}}秒']: '{{time}} секунд',
	['上一则发送后等待时间']: 'Время ожидания после отправки предыдущего сообщения',
	['上传图片']: 'Загрузить изображение',
	['主要API keys']: 'Основные API ключи',
	['主要语言']: 'основной язык',
	['事件']: 'событие',
	['以查看预览效果']: 'для просмотра предварительного эффекта',
	['依照选择模组设定UI显示位置及功能。']: 'В соответствии с выбранным модулем настройте положение и функции отображения интерфейса.',
	['依照选择的风格进行调整配色（含背景、框体、配色、线条感）。']: 'В зависимости от выбранного стиля изменить цветовую палитру (включая фон, рамки, цвета, линии).',
	['修改帐号履历成功']: 'Изменение истории аккаунта успешно',
	['修改翻译API成功']: 'Успешно изменен API перевода',
	['充值帐号']: 'Пополнить счет',
	['共 {{numOfItems}} 笔']: 'Всего {{numOfItems}} записей',
	['关 闭']: 'закрыть',
	['关闭后，整个推播系统将停止运作，所有推播讯息会暂时无效。您随时可以重新开启。']: 'После закрытия вся система уведомлений прекратит свою работу, все уведомления временно станут недействительными. Вы можете в любое время снова включить её.',
	['内容最多20字元']: 'Содержимое не более 20 символов',
	['内容预览']: 'Предпросмотр содержимого',
	['切换后，跑马灯文字与快捷键可能会出现显示不清晰或对比度不足的情况，需到后台进行重新设定']: 'После переключения текст бегущей строки и горячие клавиши могут отображаться нечетко или с недостаточной контрастностью, необходимо перенастроить в панели управления.',
	['删除履历']: 'Удалить резюме',
	['删除帐号履历成功']: 'Удаление истории аккаунта прошло успешно',
	['删除跑马灯']: 'Удалить бегущую строку',
	['加载中...']: 'Загрузка...',
	['勾选后，该账号在联系客服时，账号名称旁会显示']: 'После выбора рядом с названием аккаунта будет отображаться при обращении в службу поддержки.',
	['即时预览']: 'Мгновенный предварительный просмотр',
	['取消新增微调文本']: 'Отменить добавление текста настройки',
	['古典深色风格']: 'классический тёмный стиль',
	['單次']: 'одиночный',
	['回传表单']: 'Передать форму',
	['外观风格']: 'стиль внешнего вида',
	['客户端视觉设定']: 'Клиентская визуальная настройка',
	['客户端视觉设定成功']: 'Клиентская визуальная настройка успешно завершена',
	['尚无资料']: 'Нет данных',
	['展开']: 'Развернуть',
	['履历数量']: 'Резюме количество',
	['帐号履历']: 'История аккаунта',
	['帐号履历管理']: 'Управление историей аккаунта',
	['平台代码不能有空白']: 'Платформенный код не может содержать пробелов',
	['平台代码仅能输入英文和数字']: 'Код платформы можно вводить только на английском и цифрами.',
	['平台代码最多5码']: 'Платформенный код максимум 5 символов',
	['平台代码最少2码']: 'Платформа код минимум 2 знака',
	['平台语言']: 'платформенный язык',
	['平均首次工作时间']: 'Среднее время первой работы',
	['建立者']: 'создатель',
	['开关']: 'переключатель',
	['快速通道']: 'быстрый проход',
	['手动推播']: 'ручная рассылка',
	['手机版']: 'мобильная версия',
	['批量删除']: 'Пакетное удаление',
	['排序']: 'сортировка',
	['推播功能']: 'уведомления',
	['推播功能 OFF：推播功能关闭整个系统不运作，列表中的所有策略都无效。']: 'Функция пула выключена: функция пула отключает всю систему, все стратегии в списке не действительны.',
	['推播时间']: 'время уведомления',
	['推播讯息列表']: 'Список уведомлений',
	['推播设定']: 'Уведомления',
	['操作内容']: 'Операция',
	['收起']: 'Свернуть',
	['数值/内容']: 'число/содержание',
	['数值/内容不可为空']: 'Значение/содержание не может быть пустым',
	['数值只能输入数字、负号、小数点']: 'Числовые значения могут содержать только цифры, минус и точку.',
	['数值小数最多6位数']: 'Числовой дроби не более 6 знаков',
	['数值整数最多15位']: 'Числовое целое число максимум 15 знаков',
	['新增履历']: 'Добавить резюме',
	['新增帐号履历成功']: 'Успешно добавлена история аккаунта',
	['新增类型']: 'Добавить тип',
	['无工作']: 'Без работы',
	['时间设定需至少为 3 分钟']: 'Настройки времени должны составлять как минимум 3 минуты.',
	['是否修改翻译API?']: 'Изменить API перевода?',
	['更新成功']: 'Обновление успешно',
	['更新者']: 'обновитель',
	['架构模组']: 'архитектурный модуль',
	['栏位名称']: 'Название столбца',
	['栏位类型']: 'Тип столбца',
	['栏位类型不可为空']: 'Тип столбца не может быть пустым',
	['档案格式不符']: 'Формат файла не соответствует',
	['PDF文件']: 'Документ PDF',
	['模式与间隔时间']: 'Модель и интервал времени',
	['欢迎回来']: 'Добро пожаловать обратно',
	['此操作将自动翻译其他语言，原有输入内容将被翻译结果覆盖，请确认是否继续？']: 'Это действие автоматически переведет другие языки, и исходное содержимое будет заменено результатом перевода. Пожалуйста, подтвердите, хотите ли вы продолжить?',
	['汇入']: 'Импорт',
	['汇入微调文本成功']: 'Импорт текста настройки прошел успешно',
	['汇出微调文本成功']: 'Экспорт тонкой настройки текста завершен',
	['清空翻译']: 'Очистить перевод',
	['所有语系内容皆填写完成后才可确定，可使用自动翻译补齐其余语系']: 'Перед подтверждением необходимо заполнить содержимое на всех языках. Оставшиеся языки можно заполнить с помощью автоматического перевода.',
	['标题与内容皆需填写才可自动翻译']: 'Для автоматического перевода необходимо заполнить и заголовок, и содержимое.',
	['状态持续时间']: 'Длительность состояния',
	['用户帐号']: 'учётная запись пользователя',
	['用户帐号不能为空']: 'Пользовательская учетная запись не может быть пустой',
	['电脑版']: 'Настольная версия',
	['目前无适用推播']: 'В настоящее время нет подходящих уведомлений.',
	['目前有启用中的侦测语言平台，无法关闭']: 'В настоящее время активирована платформа обнаружения языка, которая не может быть выключена.',
	['确定删除IP白名单？']: 'Подтвердите удаление белого списка IP?',
	['确定发送推播？']: 'Вы уверены, что хотите отправить push-уведомление?',
	['确定要关闭推播功能吗？']: 'Вы уверены, что хотите отключить уведомления?',
	['确认删除此笔履历?']: 'Подтвердите удаление этой записи?',
	['确认要删除推播讯息？']: 'Подтвердить удаление уведомления?',
	['立即登入']: 'Войти немедленно',
	['第 {{min}} - {{max}} 笔/共 {{numOfItems}} 笔']: 'От {{min}} до {{max}} записей/всего {{numOfItems}} записей',
	['筛选条件']: 'Критерии отбора',
	['类型名称']: 'Тип названия',
	['系统预设模组']: 'Системный предустановленный модуль',
	['经典浅色风格']: 'классический светлый стиль',
	['翻译API']: 'Перевод API',
	['聊天介面']: 'чатовый интерфейс',
	['自动推播']: 'автоматическая рассылка',
	['自动推播功能']: 'Автоматическая отправка уведомлений',
	['自动推播功能 OFF：列表中的所有推播讯息虽然仍可被客服手动执行，但所有计时器功能停止运作。']: 'Автоматическая функция уведомлений ВЫКЛ: Все уведомления в списке все еще могут выполняться вручную службой поддержки, но все таймеры прекращают работу.',
	['自定义']: 'настраиваемый',
	['自定义文案']: 'Настраиваемый текст',
	['自客服接起对话后开始计算']: 'После того, как служба поддержки начала общение, начинается расчет.',
	['该类型目前有推播讯息套用中，无法删除']: 'Этот тип в настоящее время имеет примененные сообщения push, удалить невозможно.',
	['详细说明']: 'подробное описание',
	['请先选择推播类型']: 'Пожалуйста, выберите тип уведомления.',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔)？']: 'Пожалуйста, подтвердите, хотите ли вы удалить выбранные записи (всего {{selectedFineTuningRecordsLength}} штук)?',
	['请输入事件']: 'Введите событие',
	['请输入会员ID']: 'Введите ID участника',
	['请输入內容']: 'Введите содержимое',
	['请输入关键字']: 'Введите ключевое слово',
	['请输入您的会员 ID 以继续']: 'Введите ваш идентификатор участника, чтобы продолжить',
	['请输入数值/内容']: 'Введите значение/содержимое',
	['请输入文字']: 'Введите текст',
	['请输入栏位名称']: 'Введите название поля',
	['请输入用户帐号']: 'Введите учетную запись пользователя',
	['请输入类型名称']: 'Введите название типа',
	['请输入详细说明']: 'Введите подробное описание',
	['请选择上方下拉选单']: 'Пожалуйста, выберите пункт из выпадающего меню выше.',
	['请选择主要语言自动翻译']: 'Выберите основной язык для автоматического перевода',
	['请选择帐号状态']: 'Выберите состояние учетной записи',
	['请选择平台']: 'Выберите платформу',
	['请选择推播项目']: 'Выберите элементы для уведомлений',
	['请选择栏位类型']: 'Выберите тип поля',
	['请选择类型']: 'Выберите тип',
	['请选择类型与项目(标题)以预览内容']: 'Пожалуйста, выберите тип и проект (заголовок), чтобы предварительно просмотреть содержимое.',
	['请选择表单选项']: 'Пожалуйста, выберите вариант формы',
	['请选择运算规则']: 'Пожалуйста, выберите правило вычисления',
	['请选择预览画面']: 'Пожалуйста, выберите экран предварительного просмотра',
	['跑马灯设定']: 'бегущая строка настройка',
	['轮播']: 'карусель',
	['轮播模式']: 'Режим карусели',
	['轮播间隔时间']: 'интервал времени слайдера',
	['运算规则']: 'Операционные правила',
	['运算规则不可为空']: 'Правила операций не могут быть пустыми.',
	['返回上一层']: 'Вернуться на предыдущий уровень',
	['返回上一页']: 'Вернуться на предыдущую страницу',
	['送出推播']: 'Отправить push-уведомление',
	['选单介面']: 'меню',
	['选择推播类型']: 'Выбор типа уведомления',
	['选择推播项目(标题)']: 'Выбрать элемент уведомления (заголовок)',
	['通知时间']: 'время уведомления',
	['通知时间不能为空']: 'Время уведомления не может быть пустым',
	['重新产生Key/IV']: 'Создать новый ключ/IV',
	['重要客户']: 'важный клиент',
	['需为1~60正整数']: 'Должно быть целым положительным числом от 1 до 60.',
	['预估时间']: 'Ожидаемое время',
	['预览图片']: 'Предварительный просмотр изображения',
	['首次工作时间报表']: 'Первый отчет о рабочем времени',
	['日志管理']: 'Управление журналами',
	['API传送日志']: 'Журнал передачи API',
	['订单号']: 'Номер заказа',
	['三方单号']: 'Номер заказа третьей стороны',
	['请输入订单号']: 'Пожалуйста, введите номер заказа',
	['请输入三方单号']: 'Пожалуйста, введите номер заказа третьей стороны',
	['充值订单查询']: 'Запрос заказа на пополнение',
	['出款订单查询']: 'Запрос заказа на вывод средств',
	['开派单']: 'Создать заявку',
	['传送派单信息']: 'Отправить информацию о заявке',
	['CS传送资料']: 'Данные, отправленные CS',
	['平台回覆资料']: 'Ответные данные платформы',
	['{{text}}需以{{prefix}}开头']: '{{-text}} должен начинаться с {{-prefix}}',
	['系统通知']: 'Системное уведомление',
	['派单传送讯息']: 'Отправить сообщение заявки',
	['派单传送档案']: 'Отправить файл заявки',
	['请输入平台']: 'Пожалуйста, введите платформу',
	['派单讯息润饰设定']: 'Настройки оформления сообщения заявки',
	['此指令不会载入「AI共同设定」与「平台AI设定」，为独立的 Agent 使用']: 'Эта инструкция не загружает «Совместное задание ИИ» и «Платформа AI настройки»; используется как независимый Agent',
	['用户个人设定']: 'Личные настройки пользователя',
	['新增用户个人资讯']: 'Добавить личную информацию пользователя',
	['个人资讯参数名称']: 'Название параметра личной информации',
	['请输入个人资讯参数名称']: 'Введите название параметра личной информации',
	['*新增多个请使用逗号「 , 」隔开']: '*Чтобы добавить несколько, разделяйте их запятыми「 , 」',
	['用来设定该平台哪些个人资讯要丢给AI，只有设定在「用户个人设定」的参数，才会传送给AI']: 'Используется для настройки того, какая личная информация этой платформы передаётся ИИ. Только параметры, заданные в «Личных настройках пользователя», будут отправлены ИИ',
	['批次删除用户个人资讯']: 'Пакетное удаление личной информации пользователя',
	['确定要批次删除用户个人资讯吗？']: 'Вы уверены, что хотите пакетно удалить личную информацию пользователя?',
	['个人资讯参数名称不能为空']: 'Название параметра личной информации не может быть пустым',
	['已存在「{{name}}」']: '«{{-name}}» уже существует',
	['最多可新增{{limit}}个，已超过上限']: 'Можно добавить не более {{-limit}}; превышен лимит',
	['新增用户个人资讯成功']: 'Личная информация пользователя успешно добавлена',
	['新增用户个人资讯失败']: 'Не удалось добавить личную информацию пользователя',
	['删除用户个人资讯成功']: 'Личная информация пользователя успешно удалена',
	['删除用户个人资讯失败']: 'Не удалось удалить личную информацию пользователя',
	['图像管理']: 'Управление изображениями',
	['自定义图像']: 'Пользовательское изображение',
	['档案格式：“PNG、JPG”档案大小不得大于 500KB']: 'Формат файла: «PNG, JPG», размер файла не должен превышать 500КБ',
	['档案最大500K']: 'Файл не более 500К',
	['新增图像成功']: 'Изображение успешно добавлено',
	['删除图像成功']: 'Изображение успешно удалено',
	['是否确定删除图像？']: 'Вы уверены, что хотите удалить это изображение?',
	['内容设定']: 'Настройки содержимого',
	['英语']: 'Английский',
	['{{language}}内容']: 'Содержание на {{language}}',
	['请输入{{language}}内容']: 'Введите содержание на {{language}}',
	['请选择时间']: 'Выберите время',
	['请选择公司']: 'Выберите компанию',
	['请输入{{label}}']: 'Введите {{label}}',
	['原文参考（{{language}}）']: 'Справка по оригиналу ({{language}})',
	['确定清空设定吗？']: 'Вы уверены, что хотите очистить настройки?',
	['确定取消设定吗？']: 'Вы уверены, что хотите отменить настройки?',
	['{{language}}{{tab}}']: '{{language}} {{tab}}',
	['未完成']: 'Не завершено',
	['{{language}}{{label}}超过{{limit}}字']: '{{label}} ({{language}}) превышает {{limit}} символов',
	['公告标题']: 'Заголовок объявления',
	['进线IP']: 'Входящий IP',
	['请输入进线IP']: 'Введите входящий IP',
	['模型切换：{{fromModel}} -> {{toModel}}']: 'Переключение модели: {{fromModel}} -> {{toModel}}',
	['包网后台删除帐号后，客服系统帐号将同步删除']: 'После удаления учётной записи в бэкенде BW соответствующая учётная запись системы поддержки будет удалена синхронно',
	['系统已有新版本，请重新整理']: 'Доступна новая версия, пожалуйста, обновите.',
	['页面加载失败，请重试']: 'Не удалось загрузить страницу, повторите попытку',
	['翻译中']: 'Идёт перевод',
	['监控与即时摘要设定']: 'Настройки мониторинга и мгновенной сводки',
	['批量转接']: 'Массовое переключение',
	['已选 {{count}} 则对话']: 'Выбрано {{count}} диалогов',
	['勾选']: 'Выбрать',
	['全平台服务人数']: 'Число обслуживаемых на всех платформах',
	['未开启{{platform}}平台']: 'Платформа {{-platform}} не включена',
	['成功由 {{inviter}} 转接至 {{invitee}}，共 {{count}} 则']: 'Успешная передача от {{-inviter}} к {{-invitee}}, всего {{count}}.',
	['接受']: 'Принять',
	['拒绝({{seconds}}S)']: 'Отклонить({{seconds}}S)',
	['生成链接']: 'Создать ссылку',
	['链接生成中...']: 'Создание ссылки...',
	['复制链接']: 'Скопировать ссылку',
	['已复制链接']: 'Ссылка скопирована',
	['人工回复']: 'Ручной ответ',
	['检视回复']: 'Просмотреть ответ',
	['{{time}} AI 拦截对话']: '{{time}} ИИ перехватил диалог',
	['档案上传失败']: 'Не удалось загрузить файл',
	['转档失败，请重新上传']: 'Ошибка конвертации, загрузите файл заново',
	['AI 拦截原因与人工回复']: 'Причина перехвата ИИ и ручной ответ',
	['人工回复失败']: 'Не удалось отправить ручной ответ',
	['回复讯息']: 'Текст ответа',
	['对话摘要']: 'Сводка диалога',
	['建议回复']: 'Предлагаемый ответ',
	['拦截原因']: 'Причина перехвата',
	['拦截回复']: 'Перехваченный ответ',
	['确定送出']: 'Подтвердить и отправить',
	['生成链接失败']: 'Не удалось создать ссылку',
	['连接超时，请稍后再试']: 'Время ожидания соединения истекло, повторите попытку позже',
	['上一则']: 'Предыдущее',
	['下一则']: 'Следующее',
	['重新传送']: 'Отправить повторно',
	['传送中...']: 'Отправка...',
	['用户端翻译失败']: 'Не удалось перевести для пользователя',
	['重新传送失败']: 'Не удалось отправить повторно',
	['请确认是否删除以下模型？']: 'Подтвердите удаление следующей модели?',
	['新增模型']: 'Добавить модель',
	['请选择AI系列']: 'Выберите серию ИИ',
	['支援模型']: 'Поддерживаемая модель',
	['支援模型不能为空']: 'Поддерживаемая модель не может быть пустой',
	['请选择支援模型']: 'Выберите поддерживаемую модель',
	['AI模型管理']: 'Управление моделями ИИ',
	['模型不能为空']: 'Модель не может быть пустой',
	['请选择模型']: 'Выберите модель',

	['对话类型']: 'Тип диалога',
	['单纯AI讯息']: 'Только сообщения ИИ',
	['单纯人员讯息']: 'Только сообщения сотрудника',
	['人员+AI讯息']: 'Сообщения сотрудника + ИИ',
	['是否经过AI拦截']: 'Был ли перехват ИИ?',
	['是否修改AI拦截建议回覆']: 'Был ли изменён предлагаемый ИИ ответ?',
	['监控API keys']: 'API ключи мониторинга',
	['管理']: 'Управление',

	['启用显性快取']: 'Включить явное кэширование',
	['AI监控拦截总量']: 'Общее количество перехватов ИИ',
	['AI监控拦截']: 'Перехваты ИИ',
	['有修改建议回覆总量']: 'с изменённым предлагаемым ответом',
	['触发关键字：{{keywords}}。']: 'Сработавшие ключевые слова: {{-keywords}}.',

	['版面已套用，但尚未同步至帐号']: 'Макет применён, но ещё не синхронизирован с аккаунтом',
	['服务器重设失败，下次开启工作区时会再同步']: 'Не удалось сбросить на сервере, синхронизация повторится при следующем открытии рабочей области',
	['浏览器无法储存版面，离开前请确认帐号同步完成']: 'Браузер не может сохранить макет, перед выходом убедитесь, что синхронизация с аккаунтом завершена',

	['重设版面配置']: 'Сбросить макет',
	['确定要将版面配置回复为系统预设吗？']: 'Вернуть макет к настройкам системы по умолчанию?',
	['客服支援语言']: 'Языки поддержки службы поддержки',
	['请选择支援语言']: 'Выберите языки поддержки',
	['请选择客服支援语言']: 'Выберите языки поддержки службы поддержки',

	['删除平台']: 'Удалить платформу',
	['是否确定删除{{code}}平台']: 'Вы уверены, что хотите удалить платформу {{-code}}?',
	['删除{{code}}平台成功']: 'Платформа {{-code}} успешно удалена',
	['上传图片或PDF']: 'Загрузить изображение или PDF',
	['当前平台维护中，如有疑问请联系管理员']: 'Текущая платформа находится на техническом обслуживании. По всем вопросам обращайтесь к администратору.',
	['当前平台已禁用，如有疑问请联系管理员']: 'Текущая платформа отключена. По всем вопросам обращайтесь к администратору.',
	['收回提示文字']: 'Текст уведомления об отзыве',
	['请输入提示文字，例如：抱歉亲 妹子发错了更正一下哦！']: 'Введите текст подсказки, например: Извините, отправил по ошибке. Сейчас исправлю!',
	['标签名称']: 'Название метки',
	['预览失败']: 'Не удалось открыть предпросмотр',
	['放大']: 'Увеличить',
	['缩小']: 'Уменьшить',
	['上一页']: 'Предыдущая страница',
	['下一页']: 'Следующая страница',
	['点击预览']: 'Нажмите для предпросмотра',
};
